import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  IconButton,
  Select,
  Menu,
  MenuItem,
  Avatar,
  Fade,
  Slide,
  Grow,
  Zoom,
  keyframes,
  CircularProgress,
  Slider,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  TextField,
} from "@mui/material";
import api, { reportsAPI, callAPI, messagesAPI } from '../services/api';
import { useCallRecording } from '../contexts/CallRecordingContext';
import { useAgentStatus } from '../contexts/AgentStatusContext';
import WaveSurfer from 'wavesurfer.js';
import customerService from '../services/customerService';
import authService from '../services/authService';
import CallReports from '../components/reports/CallReports';
import freePBXWebRTCService from '../services/freePBXWebRTCService';
import { SOCKET_URL } from '../config';

import AgentReports from '../components/reports/AgentReports';
import QueueReports from '../components/reports/QueueReports';
import StatusReports from '../components/reports/StatusReports';
import CampaignDashboard from './CampaignDashboard';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { tr } from 'date-fns/locale';
import {
  IconUsers,
  IconHeadset,
  IconPercentage,
  IconDotsVertical,
  IconX,
  IconPhone,
  IconClock,
  IconTarget,
  IconTrendingUp,
  IconCircle,
  IconAlertCircle,
  IconPlayerPlay,
  IconDownload,
  IconPlus,
  IconArrowLeft,
  IconQuestionMark,
  IconPlayerPause,
  IconPlayerStop,
  IconVolume,
  IconHelp,
  IconSend,
  IconSpeakerphone,
} from "@tabler/icons-react";

// Animasyon tanımları
const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.05); opacity: 0.8; }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
`;

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

const glow = keyframes`
  0%, 100% { box-shadow: 0 0 5px rgba(59, 130, 246, 0.5); }
  50% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.8), 0 0 30px rgba(59, 130, 246, 0.6); }
`;

// ✨ Gerçek zamanlı çağrı süresi göstergesi komponenti
const CallDurationTimer: React.FC<{ startTime: string | Date | null | undefined; answerTime?: string | Date | null }> = ({ startTime, answerTime }) => {
  const [elapsed, setElapsed] = useState(0);
  
  useEffect(() => {
    // answerTime varsa onu kullan (çağrı cevaplanmış), yoksa startTime kullan
    const timeToUse = answerTime || startTime;
    
    if (!timeToUse) {
      setElapsed(0);
      return;
    }
    
    const start = new Date(timeToUse).getTime();
    
    // Geçersiz tarih kontrolü
    if (isNaN(start)) {
      setElapsed(0);
      return;
    }
    
    // İlk hesaplama
    const now = Date.now();
    const initialElapsed = Math.max(0, Math.floor((now - start) / 1000));
    setElapsed(initialElapsed);
    
    // Her saniye güncelle
    const interval = setInterval(() => {
      const currentElapsed = Math.max(0, Math.floor((Date.now() - start) / 1000));
      setElapsed(currentElapsed);
    }, 1000);
    
    return () => clearInterval(interval);
  }, [startTime, answerTime]);
  
  const hours = Math.floor(elapsed / 3600);
  const minutes = Math.floor((elapsed % 3600) / 60);
  const seconds = elapsed % 60;
  
  if (hours > 0) {
    return <>{`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`}</>;
  }
  return <>{`${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`}</>;
};

const SupervisorDashboard: React.FC = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const [statusTab, setStatusTab] = useState(0);
  const [agentsTab, setAgentsTab] = useState(0);
  const [isPerformanceModalOpen, setIsPerformanceModalOpen] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<any>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [agentPerformanceData, setAgentPerformanceData] = useState<any>(null);
  const [agentCallHistory, setAgentCallHistory] = useState<any[]>([]);
  const [loadingAgentData, setLoadingAgentData] = useState(false);
  // MT Performansı modalı: Statü süreleri (AgentPanel'deki mantığın aynısı, tablo olarak)
  const [agentStatusDurations, setAgentStatusDurations] = useState<any[]>([]);

  const [statusData, setStatusData] = useState<any[]>([]);
  const [agentsData, setAgentsData] = useState<any[]>([]);
  const [queueData, setQueueData] = useState<any[]>([]);
  const [activeCalls, setActiveCalls] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [socket, setSocket] = useState<any>(null);
  const [agentStatuses, setAgentStatuses] = useState<any[]>([]);
  // Üç nokta menüsü için state
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [menuAgent, setMenuAgent] = useState<any>(null);
  
  // Statü değiştirme dialog'u için state
  const [statusChangeDialogOpen, setStatusChangeDialogOpen] = useState(false);
  const [selectedStatusId, setSelectedStatusId] = useState('');
  const [statusChangeAgent, setStatusChangeAgent] = useState<any>(null);
  
  // Call monitoring state
  const [monitoringAgent, setMonitoringAgent] = useState<any>(null);
  const [isMonitoring, setIsMonitoring] = useState(false);
  
  // AgentStatusContext
  const agentStatusContext = useAgentStatus();

  // Sol menü: aktif bölüm (dashboard, calls, reports, support, messages, campaigns)
  const [activeSection, setActiveSection] = useState<'dashboard' | 'calls' | 'reports' | 'support' | 'messages' | 'campaigns'>('dashboard');

  // Destek talebi için state'ler
  const [supportSubject, setSupportSubject] = useState('');
  const [supportMessage, setSupportMessage] = useState('');
  const [supportPriority, setSupportPriority] = useState<'low' | 'medium' | 'high' | 'critical'>('medium');
  const [sendingSupport, setSendingSupport] = useState(false);

  // Raporlar sekmesi için state
  const [activeReportTab, setActiveReportTab] = useState<'agents' | 'calls' | 'queues' | 'status'>('calls');
  const [reportDateRange, setReportDateRange] = useState({
    startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    endDate: new Date()
  });
  const [reportLoading, setReportLoading] = useState(false);
  const [reportData, setReportData] = useState<any>(null);

  // "Çağrılar" sekmesi için durumlar
  const [calls, setCalls] = useState<any[]>([]);
  const [callsLoading, setCallsLoading] = useState<boolean>(false);
  const [callsPage, setCallsPage] = useState<number>(1);
  const [callsLimit, setCallsLimit] = useState<number>(10);
  const [callsTotalPages, setCallsTotalPages] = useState<number>(1);
  const [callsTotal, setCallsTotal] = useState<number>(0);
  
  // Filtreleme state'leri
  const [callsFilterDirection, setCallsFilterDirection] = useState<string>('all'); // all, incoming, outgoing
  const [callsFilterStatus, setCallsFilterStatus] = useState<string>('all'); // all, ended, failed, etc.
  const [callsFilterAgent, setCallsFilterAgent] = useState<string>(''); // agent name
  const [callsFilterQueue, setCallsFilterQueue] = useState<string>(''); // queue name
  const [callsFilterPhone, setCallsFilterPhone] = useState<string>(''); // phone number
  const [callsFilterStartDate, setCallsFilterStartDate] = useState<string>(''); // start date (YYYY-MM-DD)
  const [callsFilterEndDate, setCallsFilterEndDate] = useState<string>(''); // end date (YYYY-MM-DD)
  const [callsFilterFinishCode, setCallsFilterFinishCode] = useState<string>(''); // finish code

  // Call recording utilities (play/download)
  const callRecordingContext = useCallRecording();
  const { downloadRecording: crDownload, playRecording: crPlay } = callRecordingContext;
  const [playerDialog, setPlayerDialog] = useState<{ open: boolean; audioUrl: string; title: string }>({ open: false, audioUrl: '', title: '' });
  // WaveSurfer refs/state for popup waveform
  const waveformRef = useRef<HTMLDivElement | null>(null);
  const wavesurferRef = useRef<WaveSurfer | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(1);
  // Snackbar for errors/warnings
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' as 'success' | 'error' | 'warning' | 'info' });
  
  // Profile menu state
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const currentUser = authService.getCurrentUser();

  // ✨ Messages state
  const [conversations, setConversations] = useState<any[]>([]);
  const [selectedConversation, setSelectedConversation] = useState<any>(null);
  const [messages, setMessages] = useState<any[]>([]);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [allUsers, setAllUsers] = useState<any[]>([]);
  const [showUserSelectDialog, setShowUserSelectDialog] = useState(false);
  const [newMessage, setNewMessage] = useState('');
  const [selectedUser, setSelectedUser] = useState<any>(null);

  // Initialize WaveSurfer when supervisor player dialog opens (robust: retry until DOM mounted)
  useEffect(() => {
    console.debug('Supervisor player useEffect', { open: playerDialog.open, audioUrl: playerDialog.audioUrl, waveformMounted: !!waveformRef.current });

    let retryTimer: number | null = null;
    let retryCount = 0;

    const destroyWave = () => {
      try { wavesurferRef.current?.destroy(); } catch (e) { console.warn(e); }
      wavesurferRef.current = null;
    };

    const initWaveform = () => {
      // stop retrying if dialog closed
      if (!playerDialog.open || !playerDialog.audioUrl) return;

      if (!waveformRef.current) {
        if (retryCount < 20) {
          retryCount++;
          retryTimer = window.setTimeout(initWaveform, 100) as unknown as number;
          return;
        }
        console.warn('Waveform container not available after retries');
        return;
      }

      // destroy existing
      destroyWave();

      const ws = WaveSurfer.create({
        container: waveformRef.current,
        waveColor: '#e6edf3',
        progressColor: '#2563eb',
        cursorColor: '#2563eb',
        barWidth: 2,
        barRadius: 2,
        cursorWidth: 1,
        height: 80,
        barGap: 2,
        normalize: true,
      });

      wavesurferRef.current = ws;

      ws.on('ready', () => {
        const dur = ws.getDuration();
        setDuration(dur);
      });

      ws.on('audioprocess', () => {
        setCurrentTime(ws.getCurrentTime());
      });

      ws.on('play', () => setIsPlaying(true));
      ws.on('pause', () => setIsPlaying(false));
      ws.on('finish', () => setIsPlaying(false));

      ws.on('error', (e: any) => console.error('WaveSurfer error', e));

      ws.setVolume(volume);
      try {
        console.debug('WaveSurfer: loading URL', playerDialog.audioUrl);
        ws.load(playerDialog.audioUrl);
      } catch (e) {
        console.error('WaveSurfer load threw', e);
        destroyWave();
      }
    };

    // Start initialization (may retry until DOM ready)
    initWaveform();

    return () => {
      if (retryTimer) clearTimeout(retryTimer);
      destroyWave();
      setIsPlaying(false);
      setCurrentTime(0);
      setDuration(0);
    };
  }, [playerDialog.open, playerDialog.audioUrl, volume]);

  const togglePlayPause = () => {
    if (!wavesurferRef.current) return;
    wavesurferRef.current.playPause();
    setIsPlaying(!isPlaying);
  };

  const stopPlayback = () => {
    if (!wavesurferRef.current) return;
    wavesurferRef.current.stop();
    setIsPlaying(false);
    setCurrentTime(0);
  };

  const changeVolume = (val: number) => {
    setVolume(val);
    if (wavesurferRef.current) wavesurferRef.current.setVolume(val);
  };

  const showSnackbar = (message: string, severity: 'success' | 'error' | 'warning' | 'info' = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

  // Load agent statuses from context on mount
  useEffect(() => {
    agentStatusContext.fetchStatuses();
  }, []);
  useEffect(() => {
      console.log('🔄 FreePBX useEffect running, currentUser._id:', currentUser?._id);
      
      const initializeFreePBX = async () => {
        try {
          console.log('🎯 Initializing FreePBX WebRTC...');
  
          // 🎤 Mikrofon iznini hemen iste (Sayfa yüklendiğinde)
          try {
            await navigator.mediaDevices.getUserMedia({ audio: true });
            console.log('✅ Microphone permission granted on load');
          } catch (err) {
            console.error('❌ Microphone permission denied:', err);
          
          }
          
          
          

          const data = currentUser;
          if (!data.hasExtension) {
            console.warn('⚠️ Agent has no SIP extension assigned:  '+data.sipExtension);        
          }
          
          console.log('📞 Connecting to FreePBX:', data.server);
          console.log('📋 Agent credentials:', { agentId: data.agentId, extension: data.extension });
          
          // Agent bilgilerini state'e kaydet
      
          
          // 🆕 Global scope ve localStorage'a kaydet (Socket listener erişebilsin diye)
          (window as any)._agentExtension = data.sipExtension;
          localStorage.setItem('agentExtension', data.sipExtension);
          
          // FreePBX WebRTC servisine bağlan
          await freePBXWebRTCService.connect({
            extension: data.sipExtension,
            password: data.sipPassword,
            server: "wss://pbx.percrm.net:8089/ws",
            realm: "pbx.percrm.net",
            displayName: data.displayName
          });
          
          // Debug için global scope'a ekle
          (window as any).freePBXWebRTCService = freePBXWebRTCService;
          console.log('🔧 freePBXWebRTCService added to window for debugging');
          
          // Event listeners
          freePBXWebRTCService.onRegistered = () => {
            console.log('✅ FreePBX registered');
            
            // Backend'e agent bağlandı bildir
            
          };
          
          freePBXWebRTCService.onUnregistered = () => {
            console.log('❌ FreePBX unregistered');
          };
          
          freePBXWebRTCService.onReconnecting = (attempt: number, maxAttempts: number) => {
            console.log(`🔄 Reconnecting... (${attempt}/${maxAttempts})`);
            
          };

                freePBXWebRTCService.onRemoteStream = (stream: MediaStream) => {
                  const remoteAudio = document.getElementById('remoteAudio') as HTMLAudioElement;
                  if (remoteAudio) {
                    remoteAudio.srcObject = stream;
                    remoteAudio.play();
                  }
                };
          
          freePBXWebRTCService.onIncomingCall = (callerNumber: string, calledNumber: string, invitation: any) => {
            console.log('📞 onIncomingCall triggered!');
            console.log('📞 Incoming call from:', callerNumber, 'to:', calledNumber);
            
            // 1. Display Name'i al (Genellikle "Queue Name" veya "CID:QueueName" formatındadır)
            let displayName = invitation.remoteIdentity?.displayName || '';
            console.log('👤 Caller Display Name:', displayName);
  
            // 2. Headerlardan Kuyruk Bilgisi Ara
            let queueName = '';
            let sipNumber = calledNumber;
  
            try {
              const headers = invitation.request.headers;
              console.log('📜 SIP Headers:', headers);
              
              // X-Queue veya X-Queue-Name headerlarını kontrol et
              if (headers['X-Queue']) queueName = headers['X-Queue'][0].raw;
              else if (headers['X-Queue-Name']) queueName = headers['X-Queue-Name'][0].raw;
              
              // Diversion header'dan DID bul
              if (headers['Diversion']) {
                const match = headers['Diversion'][0].raw.match(/sip:(\d+)@/);
                if (match) sipNumber = match[1];
              }
            } catch (e) {
              console.warn('⚠️ Error parsing headers:', e);
            }
  
            // 3. Kuyruk ismini belirle
            // Eğer headerlardan gelmediyse, Display Name'den çıkarmaya çalış
            if (!queueName && displayName) {
               // Örnek: "Satis <0555...>" -> "Satis"
               // Örnek: "CID:Satis" -> "Satis"
               // Sadece harf ve boşluk içeren kısmı al (numaraları temizle)
               const cleanName = displayName.replace(/<.*>/, '').replace('CID:', '').trim();
               if (cleanName && cleanName !== callerNumber) {
                 queueName = cleanName;
               }
            }
  
            // Eğer hala yoksa ve DID farklıysa DID'yi kullan
            if (!queueName && sipNumber !== calledNumber) {
              queueName = `Hat: ${sipNumber}`;
            }
            
            // Eğer hiçbiri yoksa varsayılan
            if (!queueName) {
              queueName = 'Gelen Çağrı';
            }
  
            console.log('🏷️ Final Queue Name:', queueName);
            
            // 🎯 Hemen geçici ID ile başla - backend ID'sini arka planda al
            const tempCallId = `incoming-${Date.now()}`;
            
            // Zil sesini çal
            setTimeout(() => {
                               freePBXWebRTCService.acceptCall(invitation);
  console.log('⏰ 2 saniye sonra çalıştı');
}, 100);
            
            
            
            // Invitation'ı sakla (cevap vermek için)
            (window as any)._currentInvitation = invitation;
            
            // 🔄 Arka planda backend'den gerçek ID'yi al ve güncelle
           
          };
          
          freePBXWebRTCService.onCallEstablished = async (targetNumber?: string) => {
            console.log('✅ Call established', targetNumber);
           
            
            // Karşı taraf açtı bildirimi (kısa ses)
            try {
              const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
              const beepFrequency = 1000; // 1000 Hz
              const beepDuration = 0.1; // 100ms
              
              // Tek beep sesi
              const oscillator = audioContext.createOscillator();
              const gainNode = audioContext.createGain();
              
              oscillator.connect(gainNode);
              gainNode.connect(audioContext.destination);
              
              oscillator.frequency.value = beepFrequency;
              oscillator.type = 'sine';
              
              gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
              gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + beepDuration);
              
              oscillator.start(audioContext.currentTime);
              oscillator.stop(audioContext.currentTime + beepDuration);
            } catch (e) {
              console.log('Could not play beep:', e);
            }
            
            // Backend'e çağrı answered bildir
           
          };
          
          freePBXWebRTCService.onCallEnded = () => {
            console.log('📴 Call ended (remote hangup or network issue)');
            
            // Kapanma sesi çal (dit dit dit)
            console.log('🔊 Playing hangup beep...');
            try {
              const playBeep = () => {
                const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
                
                // Gerçek telefon meşgul sesi: 2 beep, pause, 2 beep, pause, 2 beep
                const beepPattern = [0, 0.25]; // Beep zamanları
                
                beepPattern.forEach(time => {
                  const oscillator = audioContext.createOscillator();
                  const gainNode = audioContext.createGain();
                  
                  oscillator.connect(gainNode);
                  gainNode.connect(audioContext.destination);
                  
                  oscillator.frequency.value = 480; // Hz
                  oscillator.type = 'sine';
                  
                  const startTime = audioContext.currentTime + time;
                  gainNode.gain.setValueAtTime(0.25, startTime);
                  gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + 0.2);
                  
                  oscillator.start(startTime);
                  oscillator.stop(startTime + 0.2);
                });
              };
              
              playBeep();
              console.log('✅ Hangup beep played');
            } catch (e) {
              console.error('❌ Could not play beep:', e);
            }
            
            // State'leri temizle
       
            // ✨ Telefon numarasını SAKLIYORUZ - müşteri kartı açık kalsın
            // setCurrentCallPhoneNumber(''); // ❌ Bunu kaldırdık
            // ⚠️ currentCallId'yi KORUYORUZ - finish code için gerekli
            // setCurrentCallId(null); ❌ Bunu kaldırdık
            // currentCallIdRef.current = null; ❌ Bunu kaldırdık
           
            // Backend'e bildir - use captured callId
            
          };
          
          
          console.log('✅ FreePBX WebRTC initialized');
          
        } catch (error) {
          console.error('❌ FreePBX initialization error:', error);
        }
      };
      
      let isInitialized = false;
      
      if (currentUser?._id && !isInitialized) {
        isInitialized = true;
        console.log('🚀 Starting FreePBX initialization for user:', currentUser._id);
        initializeFreePBX();
      }
      
      // Cleanup
      return () => {
        console.log('🧹 Cleaning up FreePBX connection...');
        freePBXWebRTCService.disconnect();
      };
    }, [currentUser?._id]);
  

  // Close profile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (showProfileMenu) {
        const target = event.target as HTMLElement;
        // Check if click is outside profile menu
        if (!target.closest('.profile-menu-container')) {
          setShowProfileMenu(false);
        }
      }
    };

    if (showProfileMenu) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showProfileMenu]);

  const openAgentMenu = (event: React.MouseEvent<HTMLElement>, agent: any) => {
    event.stopPropagation();
    console.log('🔍 Opening agent menu for:', agent);
    setMenuAnchorEl(event.currentTarget);
    setMenuAgent(agent);
  };

  const closeAgentMenu = () => {
    setMenuAnchorEl(null);
    setMenuAgent(null);
  };

  const handleOpenStatusChangeDialog = (agent: any) => {
    setStatusChangeAgent(agent);
    setSelectedStatusId(agent.currentStatusId || '');
    setStatusChangeDialogOpen(true);
    closeAgentMenu();
  };

  const handleCloseStatusChangeDialog = () => {
    setStatusChangeDialogOpen(false);
    setStatusChangeAgent(null);
    setSelectedStatusId('');
  };

  const handleChangeAgentStatus = async () => {
    if (!statusChangeAgent || !selectedStatusId) {
      setSnackbar({ open: true, message: 'Lütfen bir statü seçin', severity: 'warning' });
      return;
    }

    // Agent ID'yi al - önce id'ye bak, yoksa agent._id'yi kullan
    const agentId = statusChangeAgent.id || statusChangeAgent.agent?._id;
    
    if (!agentId) {
      setSnackbar({ open: true, message: 'Agent ID bulunamadı', severity: 'error' });
      console.error('Agent ID not found in:', statusChangeAgent);
      return;
    }

    console.log('🔄 Changing agent status:', {
      agent: statusChangeAgent,
      agentId: agentId,
      statusId: selectedStatusId
    });

    try {
      const success = await agentStatusContext.setAgentStatus(agentId, selectedStatusId);
      
      if (success) {
        setSnackbar({ open: true, message: 'Agent statüsü başarıyla değiştirildi', severity: 'success' });
        handleCloseStatusChangeDialog();
        // Agent listesi socket üzerinden otomatik güncellenecek
      } else {
        setSnackbar({ open: true, message: 'Statü değiştirilemedi', severity: 'error' });
      }
    } catch (error: any) {
      console.error('Error changing agent status:', error);
      const errorMsg = error?.response?.data?.message || 'Statü değiştirme hatası';
      setSnackbar({ open: true, message: errorMsg, severity: 'error' });
    }
  };
  // Fısıldama (Whisper)
  const handleStartMonitoringF = async (agent: any) => {
    handleStopMonitoring();
    try {
      console.log('🔍 handleStartMonitoringF (whisper) called with agent:', agent);
      console.log('🔍 Active calls:', activeCalls);
      
      const agentId = agent.id || agent.agent?._id || agent._id;
      const agentCall = activeCalls.find((call: any) => {
        const match = call.agentId === agentId || call.agent?._id === agentId || call.agentExtension === agent.extension;
        console.log('🔍 Checking call:', { 
          callId: call._id,
          callAgentId: call.agentId, 
          callAgentChannel: call.agentChannel,
          callChannel: call.channel,
          callExtension: call.agentExtension,
          searchAgentId: agentId, 
          searchExtension: agent.extension,
          match 
        });
        return match;
      });
      
      console.log('🔍 Found agent call:', agentCall);
      
      if (!agentCall) {
        showSnackbar('Agent şu anda çağrıda değil', 'warning');
        closeAgentMenu();
        return;
      }
      
      const agentChannel = agentCall.agentChannel || agentCall.channel;
      
      if (!agentChannel) {
        console.error('❌ No channel found in call:', agentCall);
        showSnackbar('Channel bilgisi eksik. Lütfen tekrar deneyin.', 'error');
        closeAgentMenu();
        return;
      }

      console.log('🎧 Starting whisper mode:', { agent, agentCall, agentChannel });

      const response = await api.post('/agent-statuses/monitor-call', {
        agentChannel: agentChannel,
        agentId: agentId,
        mode: 'whisper'
      });

      if (response.data.success) {
        setMonitoringAgent(agent);
        setIsMonitoring(true);
        showSnackbar('Fısıldama başlatıldı. Telefonunuz çalacak...', 'success');
      }

      closeAgentMenu();
    } catch (error: any) {
      console.error('❌ Error starting whisper:', error);
      const errorMsg = error?.response?.data?.message || 'Fısıldama başlatılamadı';
      showSnackbar(errorMsg, 'error');
      closeAgentMenu();
    }
  };

  // Konferans (Barge)
  const handleStartBarge = async (agent: any) => {
    handleStopMonitoring();
    try {
      console.log('🔍 handleStartBarge (conference) called with agent:', agent);
      console.log('🔍 Active calls:', activeCalls);
      
      const agentId = agent.id || agent.agent?._id || agent._id;
      const agentCall = activeCalls.find((call: any) => {
        const match = call.agentId === agentId || call.agent?._id === agentId || call.agentExtension === agent.extension;
        return match;
      });
      
      if (!agentCall) {
        showSnackbar('Agent şu anda çağrıda değil', 'warning');
        closeAgentMenu();
        return;
      }
      
      const agentChannel = agentCall.agentChannel || agentCall.channel;
      
      if (!agentChannel) {
        console.error('❌ No channel found in call:', agentCall);
        showSnackbar('Channel bilgisi eksik. Lütfen tekrar deneyin.', 'error');
        closeAgentMenu();
        return;
      }

      console.log('🎧 Starting barge mode (conference):', { agent, agentCall, agentChannel });

      const response = await api.post('/agent-statuses/monitor-call', {
        agentChannel: agentChannel,
        agentId: agentId,
        mode: 'barge'
      });

      if (response.data.success) {
        setMonitoringAgent(agent);
        setIsMonitoring(true);
        showSnackbar('Konferans başlatıldı. Telefonunuz çalacak...', 'success');
      }

      closeAgentMenu();
    } catch (error: any) {
      console.error('❌ Error starting barge:', error);
      const errorMsg = error?.response?.data?.message || 'Konferans başlatılamadı';
      showSnackbar(errorMsg, 'error');
      closeAgentMenu();
    }
  };

  // ✨ Messaging functions for supervisor
  const loadUsers = async () => {
    try {
      const response = await messagesAPI.getUsers();
      if (response.data.success) {
        setAllUsers(response.data.data);
      }
    } catch (error) {
      console.error('❌ Error loading users:', error);
    }
  };

  const loadSupervisorConversations = async () => {
    try {
      setLoadingMessages(true);
      const response = await messagesAPI.getConversations();
      if (response.data.success) {
        setConversations(response.data.data);
      }
    } catch (error) {
      console.error('❌ Error loading supervisor conversations:', error);
      showSnackbar('Konuşmalar yüklenirken hata oluştu', 'error');
    } finally {
      setLoadingMessages(false);
    }
  };

  const loadConversationMessages = async (userId1: string, userId2: string) => {
    try {
      setLoadingMessages(true);
      // Supervisor can see any conversation - just use first userId
      const response = await messagesAPI.getConversation(userId1);
      if (response.data.success) {
        // Filter messages to show only those between these two users
        const filteredMessages = response.data.data.filter((msg: any) => 
          (msg.senderId?._id === userId1 && msg.receiverId?._id === userId2) ||
          (msg.senderId?._id === userId2 && msg.receiverId?._id === userId1)
        );
        setMessages(filteredMessages);
      }
    } catch (error) {
      console.error('❌ Error loading conversation messages:', error);
      showSnackbar('Mesajlar yüklenirken hata oluştu', 'error');
    } finally {
      setLoadingMessages(false);
    }
  };

  const handleSendMessage = async () => {
    if (!newMessage.trim() || !selectedUser) return;

    try {
      const messageContent = newMessage.trim();
      const recipientId = selectedUser._id;
      setNewMessage('');

      // Send to backend
      const response = await messagesAPI.send(recipientId, messageContent);
      
      if (response.data.success) {
        const sentMessage = response.data.data;
        
        // Add message to local state if we have selectedUser
        if (selectedUser && !selectedConversation) {
          // New conversation - add the first message
          setMessages([sentMessage]);
          
          // Create a mock conversation object
          setSelectedConversation({
            _id: { user1: currentUser._id, user2: recipientId },
            lastMessage: sentMessage
          });
        } else if (selectedConversation) {
          // Existing conversation - reload messages
          loadConversationMessages(
            selectedConversation.lastMessage.senderId._id, 
            selectedConversation.lastMessage.receiverId._id
          );
        }
        
        // Always reload conversations list
        loadSupervisorConversations();
        showSnackbar('Mesaj gönderildi', 'success');
      }
    } catch (error) {
      console.error('❌ Error sending message:', error);
      showSnackbar('Mesaj gönderilemedi', 'error');
    }
  };

  // Call monitoring functions
  const handleStartMonitoring = async (agent: any) => {
    try {
      console.log('🔍 handleStartMonitoring called with agent:', agent);
      console.log('🔍 Active calls:', activeCalls);
      
      // Try multiple ways to match agent ID
      const agentId = agent.id || agent.agent?._id || agent._id;
      const agentCall = activeCalls.find((call: any) => {
        const match = call.agentId === agentId || call.agent?._id === agentId || call.agentExtension === agent.extension;
        console.log('🔍 Checking call:', { 
          callId: call._id,
          callAgentId: call.agentId, 
          callAgentChannel: call.agentChannel,
          callChannel: call.channel,
          callExtension: call.agentExtension,
          searchAgentId: agentId, 
          searchExtension: agent.extension,
          match 
        });
        return match;
      });
      
      console.log('🔍 Found agent call:', agentCall);
      
      if (!agentCall) {
        showSnackbar('Agent şu anda çağrıda değil', 'warning');
        closeAgentMenu();
        return;
      }
      
      const agentChannel = agentCall.agentChannel || agentCall.channel;
      
      if (!agentChannel) {
        console.error('❌ No channel found in call:', agentCall);
        showSnackbar('Channel bilgisi eksik. Lütfen tekrar deneyin.', 'error');
        closeAgentMenu();
        return;
      }

      console.log('🎧 Starting call monitoring:', { agent, agentCall, agentChannel });

      const response = await api.post('/agent-statuses/monitor-call', {
        agentChannel: agentChannel,
        agentId: agentId,
        mode: 'listen'
      });

      if (response.data.success) {
        setMonitoringAgent(agent);
        setIsMonitoring(true);
        showSnackbar('Dinleme başlatıldı. Telefonunuz çalacak...', 'success');
      }

      closeAgentMenu();
    } catch (error: any) {
      console.error('❌ Error starting monitoring:', error);
      const errorMsg = error?.response?.data?.message || 'Dinleme başlatılamadı';
      showSnackbar(errorMsg, 'error');
      closeAgentMenu();
    }
  };

  const handleStopMonitoring = async () => {
    try {
      const response = await api.post('/agent-statuses/stop-monitor');

      if (response.data.success) {
        showSnackbar('Dinleme durduruldu', 'success');
      }

      setMonitoringAgent(null);
      setIsMonitoring(false);
    } catch (error: any) {
      console.error('❌ Error stopping monitoring:', error);
      const errorMsg = error?.response?.data?.message || 'Dinleme durdurulamadı';
      showSnackbar(errorMsg, 'error');
    }
  };

  // ✨ Get status color from database or fallback
  const getStatusColor = (statusName: string) => {
    if (!statusName) return "#6b7280";
    
    // First try to find in agentStatuses from database
    const status = agentStatuses.find((s: any) => 
      s.name?.toLowerCase() === statusName.toLowerCase() ||
      s.name === statusName
    );
    if (status?.color) {
      return status.color;
    }
    
    // Fallback to hardcoded colors for backward compatibility
    const statusLower = (statusName || '').toLowerCase();
    if (statusLower.includes('available') || statusLower.includes('hazır') || statusLower === 'available' || statusLower === 'hazır') {
      return "#10b981";
    } else if (statusLower.includes('backoffice') || statusLower.includes('ofis') || statusLower === 'backoffice') {
      return "#3b82f6";
    } else if (statusLower.includes('not answering') || statusLower.includes('cevap vermiyor') || statusLower.includes('offline') || statusLower === 'not answering') {
      return "#ef4444";
    } else {
      return "#6b7280";
    }
  };

  const handleAgentClick = async (agent: any) => {
    setSelectedAgent(agent);
    setIsPerformanceModalOpen(true);
    setLoadingAgentData(true);

    try {
      // Get agent ID - agent listesinde "id" olarak geliyor, agent objesinde "_id" olabilir
      const agentId = agent.id || agent._id || agent.agent?._id;
      
      console.log('📊 handleAgentClick - agent:', agent);
      console.log('📊 handleAgentClick - agentId:', agentId);

      if (!agentId) {
        console.error('No agent ID found in:', agent);
        setLoadingAgentData(false);
        return;
      }

      // Format duration helper
      const formatDuration = (seconds: number) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
      };
      
      // Load performance data - agent-stats'tan al (bugünün verisi)
      const statsResponse = await api.get(`/agent-stats/today/${agentId}`);
      const stats = statsResponse?.data?.data || {};
      
      // Eski formata dönüştür
      const perfResponse = {
        data: {
          success: true,
          data: {
            totalCalls: stats.totalCalls || 0,
            answeredCalls: stats.answeredCalls || 0,
            missedCalls: stats.missedCalls || 0,
            averageCallDuration: stats.avgCallDuration || 0,
            averageWaitTime: 0, // TODO: waitTime hesaplansın
            successRate: stats.totalCalls > 0 ? Math.round((stats.answeredCalls / stats.totalCalls) * 100) : 0
          }
        }
      };
      
      const callStatsResponse = {
        data: {
          success: true,
          callStats: {
            incomingCalls: stats.incomingCalls || 0,
            outgoingCalls: stats.outgoingCalls || 0,
            totalCallDuration: formatDuration(stats.totalDuration || 0),
            incomingCallDuration: formatDuration(stats.incomingDuration || 0),
            outgoingCallDuration: formatDuration(stats.outgoingDuration || 0),
            avgTotalCallDuration: formatDuration(stats.avgCallDuration || 0),
            avgIncomingCallDuration: formatDuration(stats.avgIncomingDuration || 0),
            avgOutgoingCallDuration: formatDuration(stats.avgOutgoingDuration || 0)
          }
        }
      };

      // Load call history
      const historyResponse = await callAPI.getAgentCallHistory(agentId);

      // Load status durations (Bugün) — AgentPanel ile aynı mantık
      const todayDate = new Date();
      const startOfDay = new Date(todayDate);
      startOfDay.setHours(0, 0, 0, 0);
      const endOfDay = new Date(todayDate);
      endOfDay.setHours(23, 59, 59, 999);
      let statusDurationsResponse: any = null;
      try {
        // AgentPanel'de kullanılan endpoint
        // reportsAPI.getAgentStatusDurations(agentId, startISO, endISO)
        // Not: reportsAPI importu zaten mevcut.
        statusDurationsResponse = await reportsAPI.getAgentStatusDurations(
          agentId,
          startOfDay.toISOString(),
          endOfDay.toISOString()
        );
      } catch (e) {
        console.error('Error loading status durations:', e);
      }

      if (perfResponse.data?.success) {
        const perf = perfResponse.data.data || {};
        const callStats = callStatsResponse.data?.callStats || {};

        setAgentPerformanceData({
          totalCalls: perf.totalCalls || 0,
          answeredCalls: perf.answeredCalls || 0,
          missedCalls: perf.missedCalls || 0,
          avgCallDuration: typeof perf.averageCallDuration === 'number' ? formatDuration(perf.averageCallDuration) : '00:00:00',
          avgWaitTime: typeof perf.averageWaitTime === 'number' ? formatDuration(perf.averageWaitTime) : '00:00:00',
          satisfactionRate: perf.successRate || 0,
          incomingCalls: callStats.incomingCalls || 0,
          outgoingCalls: callStats.outgoingCalls || 0,
          totalCallDuration: callStats.totalCallDuration || '00:00:00',
          incomingCallDuration: callStats.incomingCallDuration || '00:00:00',
          outgoingCallDuration: callStats.outgoingCallDuration || '00:00:00',
          avgTotalCallDuration: callStats.avgTotalCallDuration || '00:00:00',
          avgIncomingCallDuration: callStats.avgIncomingCallDuration || '00:00:00',
          avgOutgoingCallDuration: callStats.avgOutgoingCallDuration || '00:00:00'
        });
      }

      if (historyResponse.data?.success) {
        // Backend response shape: { success: true, data: [...], pagination: {...} }
        // Previously we were reading historyResponse.data.calls which is undefined.
        const calls = Array.isArray(historyResponse.data?.data)
          ? historyResponse.data.data
          : [];
        setAgentCallHistory(calls);
      }

      // Set status durations
      if (statusDurationsResponse?.data?.success && Array.isArray(statusDurationsResponse.data.statusDurations)) {
        const raw = statusDurationsResponse.data.statusDurations;
        // Toplam süreyi hesapla (saniye)
        const totalSec = raw.reduce((acc: number, s: any) => {
          const sec = typeof s.durationSeconds === 'number'
            ? s.durationSeconds
            : (typeof s.totalDuration === 'number' ? s.totalDuration : 0);
          return acc + (sec > 0 ? sec : 0);
        }, 0);

        // Oranı yüzde olarak hesapla (toplam gün içi süreye göre)
        const withRatio = raw.map((s: any) => {
          const sec = typeof s.durationSeconds === 'number'
            ? s.durationSeconds
            : (typeof s.totalDuration === 'number' ? s.totalDuration : 0);
          const ratio = (typeof s.ratio === 'number' || typeof s.percentage === 'number')
            ? (s.ratio ?? s.percentage)
            : (totalSec > 0 ? (sec / totalSec) * 100 : 0);
          return { ...s, ratio };
        });

        setAgentStatusDurations(withRatio);
      } else {
        setAgentStatusDurations([]);
      }

    } catch (error) {
      console.error('Error loading agent data:', error);
    } finally {
      setLoadingAgentData(false);
    }
  };

  // Destek talebi gönderme fonksiyonu
  const handleSendSupport = async () => {
    if (!supportSubject.trim() || !supportMessage.trim()) {
      setSnackbar({ open: true, message: 'Lütfen konu ve mesaj alanlarını doldurun', severity: 'error' });
      return;
    }

    setSendingSupport(true);
    try {
      const res = await api.post('/support/send-ticket', {
        subject: supportSubject,
        message: supportMessage,
        priority: supportPriority,
        senderName: currentUser?.name || currentUser?.username || 'Bilinmeyen',
        senderEmail: currentUser?.email || '',
        senderRole: currentUser?.role || 'supervisor',
        locationId: currentUser?.locationId || null
      });

      if (res.data?.success) {
        setSnackbar({ open: true, message: 'Destek talebiniz başarıyla gönderildi', severity: 'success' });
        setSupportSubject('');
        setSupportMessage('');
        setSupportPriority('medium');
      } else {
        setSnackbar({ open: true, message: res.data?.message || 'Destek talebi gönderilemedi', severity: 'error' });
      }
    } catch (error: any) {
      console.error('Error sending support ticket:', error);
      setSnackbar({ open: true, message: error?.response?.data?.message || 'Destek talebi gönderilirken hata oluştu', severity: 'error' });
    } finally {
      setSendingSupport(false);
    }
  };

  // Yardımcılar
  const formatDateTR = (iso?: string) => {
    if (!iso) return '-';
    try {
      return new Date(iso).toLocaleString('tr-TR', { timeZone: 'Europe/Istanbul' });
    } catch {
      return iso;
    }
  };

  const formatDurationHHMMSS = (totalSeconds?: number) => {
    const seconds = Math.max(0, Number(totalSeconds || 0));
    const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
    const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
    const s = Math.floor(seconds % 60).toString().padStart(2, '0');
    return `${h}:${m}:${s}`;
  };

  // Tüm çağrıları yükle (filtreleme için)
  const [allCalls, setAllCalls] = useState<any[]>([]);
  
  // Tüm agent kullanıcıları (filtreleme için)
  const [allAgents, setAllAgents] = useState<any[]>([]);
  
  // Tüm aktif kuyruklar (filtreleme için)
  const [allQueues, setAllQueues] = useState<any[]>([]);
  
  const loadAllCalls = async () => {
    try {
      setCallsLoading(true);
      const res = await callAPI.getAll({ page: '1', limit: '10000' });
      if (res.data?.success) {
        const arr = Array.isArray(res.data.data) ? res.data.data : [];

        // Müşteri kartından finish code'ları al
        try {
          const getPhoneFromCall = (c: any) => {
            const dir = c?.direction;
            const phone = dir === 'outgoing'
              ? (c?.calledNumber || c?.callerNumber)
              : (c?.callerNumber || c?.calledNumber);
            return (phone || '').toString();
          };

          const uniquePhones = Array.from(new Set(arr.map(getPhoneFromCall).filter(Boolean))) as string[];
          const phoneToCustomerMap = new Map<string, any>();
          
          await Promise.all(uniquePhones.map(async (phone: string) => {
            try {
              const customer = await customerService.getCustomerByPhone(phone);
              if (customer) {
                phoneToCustomerMap.set(phone, customer);
              }
            } catch (_) {
              // Sessizce geç
            }
          }));

          const enriched = arr.map((c: any) => {
            const phone = getPhoneFromCall(c);
            const customer = phoneToCustomerMap.get(phone);
            
            if (!customer) return c;
            
            // Finish code - çağrı tarihine göre müşteri kartından bul
            let finishCode = '-';
            if (customer.finishCodes && Array.isArray(customer.finishCodes) && c.startTime) {
              const callDate = new Date(c.startTime);
              const callDateStr = callDate.toDateString();
              
              // Aynı gün içinde en son eklenen finish code'u bul
              const matchingFinishCodes = customer.finishCodes.filter((fc: any) => {
                if (!fc.createdAt) return false;
                const fcDate = new Date(fc.createdAt);
                return fcDate.toDateString() === callDateStr;
              });
              
              if (matchingFinishCodes.length > 0) {
                // En son eklenen finish code'u al
                const latestFinishCode = matchingFinishCodes.sort((a: any, b: any) => {
                  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
                })[0];
                finishCode = latestFinishCode.code || '-';
              }
            }
            
            return {
              ...c,
              finishCode: finishCode
            };
          });

          setAllCalls(enriched);
        } catch (e) {
          console.warn('⚠️ Finish code zenginleştirme hatası:', (e as any)?.message || e);
          setAllCalls(arr);
        }
      } else {
        setAllCalls([]);
      }
    } catch (e) {
      console.error('❌ Calls load error:', e);
      setAllCalls([]);
    } finally {
      setCallsLoading(false);
    }
  };

  // Frontend'de filtreleme ve sayfalama
  const getFilteredAndPaginatedCalls = () => {
    // Kuyruksuz çağrıları her zaman filtrele
    let filtered = allCalls.filter((c: any) => c.queueId);

    // Eğer kullanıcı ivrSupervisor ise sadece ona atanmış kuyruklardan ve IVR'dan yönlendirilmiş çağrılar gözüksün
    if (authService.hasRole('ivrSupervisor')) {
      const userQueueIds = authService.getUserQueueIds();
      filtered = filtered.filter((c: any) => {
        // Sadece IVR'dan yönlendirilmiş ve kullanıcının kuyruklarından gelen çağrılar
        const isIVRForwarded = !!c.forwardedTo;
        const inUserQueue = c.queueId && userQueueIds.includes(c.queueId._id || c.queueId);
        return isIVRForwarded && inUserQueue;
      });
    }

    // Çağrı yönü filtresi
    if (callsFilterDirection !== 'all') {
      filtered = filtered.filter((c: any) => c.direction === callsFilterDirection);
    }

    // Durum filtresi
    if (callsFilterStatus !== 'all') {
      filtered = filtered.filter((c: any) => c.status === callsFilterStatus);
    }

    // Temsilci filtresi
    if (callsFilterAgent) {
      filtered = filtered.filter((c: any) => {
        const agentName = c.agentId ? `${c.agentId.firstName || ''} ${c.agentId.lastName || ''}`.trim() : '-';
        return agentName === callsFilterAgent;
      });
    }

    // Kuyruk filtresi
    if (callsFilterQueue) {
      filtered = filtered.filter((c: any) => (c.queueId?.name || '-') === callsFilterQueue);
    }

    // Telefon filtresi
    if (callsFilterPhone) {
      filtered = filtered.filter((c: any) => {
        const dir = c.direction || '-';
        const phone = dir === 'outgoing' ? (c.calledNumber || c.callerNumber || '-') : (c.callerNumber || c.calledNumber || '-');
        return phone.includes(callsFilterPhone);
      });
    }

    // Tarih filtresi
    if (callsFilterStartDate || callsFilterEndDate) {
      filtered = filtered.filter((c: any) => {
        const callDate = c.startTime || c.createdAt;
        if (!callDate) return false;
        
        const callDateTime = new Date(callDate);
        
        // Başlangıç tarihi kontrolü
        if (callsFilterStartDate) {
          const startDate = new Date(callsFilterStartDate);
          startDate.setHours(0, 0, 0, 0);
          if (callDateTime < startDate) return false;
        }
        
        // Bitiş tarihi kontrolü
        if (callsFilterEndDate) {
          const endDate = new Date(callsFilterEndDate);
          endDate.setHours(23, 59, 59, 999);
          if (callDateTime > endDate) return false;
        }
        
        return true;
      });
    }

    // Finish code filtresi
    if (callsFilterFinishCode) {
      filtered = filtered.filter((c: any) => {
        const finishCode = c.finishCode || '-';
        return finishCode.toLowerCase().includes(callsFilterFinishCode.toLowerCase());
      });
    }

    // Toplam sayı
    const total = filtered.length;
    const totalPages = Math.ceil(total / callsLimit);

    // Sayfalama
    const startIndex = (callsPage - 1) * callsLimit;
    const endIndex = startIndex + callsLimit;
    const paginatedCalls = filtered.slice(startIndex, endIndex);

    return { calls: paginatedCalls, total, totalPages };
  };

  // Calls sekmesine girince tüm çağrıları yükle
  useEffect(() => {
    if (activeSection === 'calls') {
      loadAllCalls();
      setCallsPage(1);
    }
    // ✨ Load messages when messages section is opened
    if (activeSection === 'messages') {
      loadUsers();
      loadSupervisorConversations();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Filtreleme veya sayfalama değiştiğinde tabloyu güncelle
  useEffect(() => {
    const { calls: filteredCalls, total, totalPages } = getFilteredAndPaginatedCalls();
    setCalls(filteredCalls);
    setCallsTotal(total);
    setCallsTotalPages(totalPages);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allCalls, callsPage, callsLimit, callsFilterDirection, callsFilterStatus, callsFilterAgent, callsFilterQueue, callsFilterPhone, callsFilterStartDate, callsFilterEndDate, callsFilterFinishCode]);

  const handleCloseModal = () => {
    setIsPerformanceModalOpen(false);
    setSelectedAgent(null);
    setAgentPerformanceData(null);
    setAgentCallHistory([]);
    setAgentStatusDurations([]);
  };

  // ✨ Update status counts from current agentsData
  const updateStatusCounts = () => {
    const statusCountsMap: Record<string, number> = {};
    
    // Initialize all statuses with 0 count
    agentStatuses.forEach((status: any) => {
      if (status.isActive !== false) {
        statusCountsMap[status.name] = 0;
      }
    });
    
    // Count agents by status
    agentsData.forEach((agent: any) => {
      const statusName = agent.status || 'Not Answering';
      if (statusCountsMap.hasOwnProperty(statusName)) {
        statusCountsMap[statusName]++;
      } else {
        // If status not found in database, add it with default color
        statusCountsMap[statusName] = (statusCountsMap[statusName] || 0) + 1;
      }
    });
    
    // ✨ Build status data array with colors from database
    const statusDataArray = Object.entries(statusCountsMap)
      .map(([statusName, count]) => {
        const statusInfo = agentStatuses.find((s: any) => s.name === statusName);
        return {
          label: statusName,
          count: count as number,
          color: statusInfo?.color || getStatusColor(statusName)
        };
      })
      .filter((item) => item.count > 0) // Only show statuses with agents
      .sort((a, b) => b.count - a.count); // Sort by count descending
    
    setStatusData(statusDataArray);
  };

  // ✨ Load live monitoring data
  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      navigate('/login');
      return;
    }
    
    const loadData = async () => {
      try {
        setLoading(true);
        
        // ✨ Tüm çağrıları yükle (dashboard için de gerekli)
        let loadedCalls: any[] = [];
        try {
          const callsRes = await callAPI.getAll({ page: '1', limit: '10000' });
          if (callsRes.data?.success) {
            const arr = Array.isArray(callsRes.data.data) ? callsRes.data.data : [];

            // Müşteri kartından finish code'ları al
            try {
              const getPhoneFromCall = (c: any) => {
                const dir = c?.direction;
                const phone = dir === 'outgoing'
                  ? (c?.calledNumber || c?.callerNumber)
                  : (c?.callerNumber || c?.calledNumber);
                return (phone || '').toString();
              };

              const uniquePhones = Array.from(new Set(arr.map(getPhoneFromCall).filter(Boolean))) as string[];
              const phoneToCustomerMap = new Map<string, any>();
              
              await Promise.all(uniquePhones.map(async (phone: string) => {
                try {
                  const customer = await customerService.getCustomerByPhone(phone);
                  if (customer) {
                    phoneToCustomerMap.set(phone, customer);
                  }
                } catch (_) {
                  // Sessizce geç
                }
              }));

              const enriched = arr.map((c: any) => {
                const phone = getPhoneFromCall(c);
                const customer = phoneToCustomerMap.get(phone);
                
                if (!customer) return c;
                
                // Finish code - çağrı tarihine göre müşteri kartından bul
                let finishCode = '-';
                if (customer.finishCodes && Array.isArray(customer.finishCodes) && c.startTime) {
                  const callDate = new Date(c.startTime);
                  const callDateStr = callDate.toDateString();
                  
                  // Aynı gün içinde en son eklenen finish code'u bul
                  const matchingFinishCodes = customer.finishCodes.filter((fc: any) => {
                    if (!fc.createdAt) return false;
                    const fcDate = new Date(fc.createdAt);
                    return fcDate.toDateString() === callDateStr;
                  });
                  
                  if (matchingFinishCodes.length > 0) {
                    // En son eklenen finish code'u al
                    const latestFinishCode = matchingFinishCodes.sort((a: any, b: any) => {
                      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
                    })[0];
                    finishCode = latestFinishCode.code || '-';
                  }
                }
                
                return {
                  ...c,
                  finishCode: finishCode
                };
              });

              loadedCalls = enriched;
              setAllCalls(enriched);
            } catch (e) {
              console.warn('⚠️ Finish code zenginleştirme hatası:', (e as any)?.message || e);
              loadedCalls = arr;
              setAllCalls(arr);
            }
          } else {
            loadedCalls = [];
            setAllCalls([]);
          }
        } catch (e) {
          console.error('❌ Calls load error:', e);
          loadedCalls = [];
          setAllCalls([]);
        }
        
        console.log('📞 DEBUG: loadedCalls length:', loadedCalls.length);
        console.log('📞 DEBUG: loadedCalls sample:', loadedCalls.slice(0, 3));
        
        // ✨ Fetch agent statuses from database
        const statusesResponse = await reportsAPI.getAgentStatuses();
        const statuses = statusesResponse?.data?.data || statusesResponse?.data || [];
        const statusesList = Array.isArray(statuses) ? statuses : [];
        setAgentStatuses(statusesList);
        console.log('📊 Supervisor Dashboard: Agent statuses:', statusesList);
        
        // Fetch active agents - yeni agent-stats API'sinden gelen veri
        const agentsStatsResponse = await reportsAPI.getActiveAgents();
        const agentStats = agentsStatsResponse?.data?.data || agentsStatsResponse?.data || [];
        const agentStatsList = Array.isArray(agentStats) ? agentStats : [];
        
        // Fetch gerçek agent bilgileri (status, queue, vs) - eski endpoint
        const agentsInfoResponse = await api.get('/reports/agents');
        const agentsInfo = agentsInfoResponse?.data?.data || agentsInfoResponse?.data || [];
        const agentsInfoList = Array.isArray(agentsInfo) ? agentsInfo : [];
        
        console.log('📊 Supervisor Dashboard: Agent stats:', agentStatsList.length);
        console.log('📊 Supervisor Dashboard: Agent info:', agentsInfoList.length);
        
        // ✨ Tüm agent kullanıcılarını set et (filtreleme için)
        setAllAgents(agentsInfoList);
        
        // ✨ DEBUG: allCalls'ı kontrol et
        console.log('📞 DEBUG: allCalls length:', allCalls.length);
        console.log('📞 DEBUG: allCalls sample:', allCalls.slice(0, 3));
        
        // Transform agents data for display - stats ve info'yu birleştir
        const transformedAgents = agentsInfoList.map((agent: any) => {
          const agentId = agent._id;
          
          // Bu agent için stats bul
          const stat = agentStatsList.find((s: any) => s.agentId === agentId);
          
          // Stats verilerini al
          const totalCalls = stat?.totalCalls || 0;
          const incomingCalls = stat?.incomingCalls || 0;
          const outgoingCalls = stat?.outgoingCalls || 0;
          const totalDuration = stat?.totalDuration || 0;
          const avgCallDuration = stat?.avgCallDuration || 0;
          
          // Debug log
          console.log(`📊 Agent ${agent.firstName} ${agent.lastName}:`, {
            totalCalls,
            incomingCalls,
            outgoingCalls,
            stat
          });
          
          const totalCallDurationStr = totalDuration > 0 
            ? `${Math.floor(totalDuration / 60)}:${String(totalDuration % 60).padStart(2, '0')}`
            : '00:00';
          
          // Status bilgisi
          const statusName = agent.currentStatusId?.name || 'Not Answering';
          
          // Mevcut agentsData'dan statusStartTime'ı al (eğer statü aynıysa)
          const existingAgent = agentsData.find((a: any) => a.id === agentId);
          let statusStartTime: Date;
          
          if (existingAgent && existingAgent.status === statusName && existingAgent.statusStartTime) {
            statusStartTime = existingAgent.statusStartTime;
          } else {
            statusStartTime = agent.statusStartTime ? new Date(agent.statusStartTime) : new Date();
          }
          
          const statusChangeTime = statusStartTime.toLocaleString('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
          
          const now = new Date();
          const diffSeconds = Math.floor((now.getTime() - statusStartTime.getTime()) / 1000);
          const minutes = Math.floor(diffSeconds / 60);
          const seconds = diffSeconds % 60;
          const durationStr = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          
          // Queue bilgisi
          const queueDisplay = agent.currentCall?.queueName
            || agent.selectedQueueName
            || (agent.queueIds && agent.queueIds.length > 0
                ? agent.queueIds.map((q: any) => q?.name || q?.extension).filter(Boolean).join(', ')
                : '-');

          return {
            id: agentId,
            name: `${agent.firstName || ''} ${agent.lastName || ''}`.trim() || agent.email || 'Unknown',
            avatar: (agent.firstName?.[0] || agent.email?.[0] || 'A').toUpperCase(),
            extension: agent.extension || '-',
            status: statusName,
            duration: durationStr,
            statusStartTime: statusStartTime,
            statusChangeTime: statusChangeTime,
            queue: queueDisplay,
            callDirection: agent.callDirection || null,
            incomingCalls: incomingCalls,
            outgoingCalls: outgoingCalls,
            totalCalls: totalCalls,
            totalCallDuration: totalCallDurationStr,
            avgCallDuration: avgCallDuration,
            agent: agent
          };
        });
        
        setAgentsData(transformedAgents);
        
        // ✨ Calculate status counts dynamically from all statuses
        const statusCountsMap: Record<string, number> = {};
        
        // Initialize all statuses with 0 count
        statusesList.forEach((status: any) => {
          if (status.isActive !== false) {
            statusCountsMap[status.name] = 0;
          }
        });
        
        // Count agents by status
        transformedAgents.forEach((agent: any) => {
          const statusName = agent.status || 'Not Answering';
          if (statusCountsMap.hasOwnProperty(statusName)) {
            statusCountsMap[statusName]++;
          } else {
            // If status not found in database, add it with default color
            statusCountsMap[statusName] = (statusCountsMap[statusName] || 0) + 1;
          }
        });
        
        // ✨ Build status data array with colors from database
        const statusDataArray = Object.entries(statusCountsMap)
          .map(([statusName, count]) => {
            const statusInfo = statusesList.find((s: any) => s.name === statusName);
            return {
              label: statusName,
              count: count as number,
              color: statusInfo?.color || getStatusColor(statusName)
            };
          })
          .filter((item) => item.count > 0) // Only show statuses with agents
          .sort((a, b) => b.count - a.count); // Sort by count descending
        
        setStatusData(statusDataArray);
        
        // Fetch queue performance
        // ✨ Bugünün tarihi için tarih parametreleri gönder
        const todayIso = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
        const startOfDay = `${todayIso}T00:00:00.000Z`;
        const endOfDay = `${todayIso}T23:59:59.999Z`;
        const queueResponse = await reportsAPI.getQueuePerformance(startOfDay, endOfDay);
        // ✨ Axios response format: response.data = { success: true, data: {...} }
        const queues = queueResponse?.data?.data || queueResponse?.data || [];
        const queueList = Array.isArray(queues) ? queues : [];
        
        // ✨ Tüm aktif kuyrukları set et (filtreleme için)
        setAllQueues(queueList);
        
        // Transform queue data for display
        const transformedQueues = queueList.map((queue: any) => ({
          name: queue.name || queue.queueName || '-',
          total: queue.statistics?.totalCalls || queue.total || 0,
          answered: queue.statistics?.answeredCalls || queue.answered || 0,
          missed: queue.statistics?.missedCalls || queue.missed || 0,
          sl1: queue.statistics?.successRate || 0,
          queue: queue
        }));
        
        setQueueData(transformedQueues);
        
        // ✨ Fetch active calls
        const activeCallsResponse = await callAPI.getActive();
        const activeCallsList = activeCallsResponse?.data?.data || activeCallsResponse?.data || [];
        const activeCallsArray = Array.isArray(activeCallsList) ? activeCallsList
          .filter((call: any) => call.queueId) // Kuyruksuz çağrıları gösterme
          .map((call: any) => {
          // Extract agent ID if it's an object
          const agentId = call.agentId ? (typeof call.agentId === 'object' ? call.agentId._id : call.agentId) : undefined;
          return {
            ...call,
            agentId: agentId,
            agentChannel: call.channel, // Map channel to agentChannel
            agentExtension: call.agentId?.extension || call.agentExtension
          };
        }) : [];
        console.log('📞 Supervisor Dashboard: Active calls:', activeCallsArray);
        setActiveCalls(activeCallsArray);
        
      } catch (error) {
        console.error('❌ Error loading supervisor dashboard data:', error);
      } finally {
        setLoading(false);
        // Sayfa yüklendiğinde animasyonu başlat
        setTimeout(() => {
          setIsLoaded(true);
        }, 100);
      }
    };
    
    void loadData();
    
    // ✨ Socket.IO connection for live updates
    const socketUrl = SOCKET_URL;
    const newSocket = io(socketUrl);
    setSocket(newSocket);
    
    newSocket.on('connect', () => {
      console.log('🔌 Supervisor Dashboard: Socket connected:', newSocket.id);
      // Join supervisor room to receive updates
      newSocket.emit('join-supervisor-room');
      console.log('✅ Supervisor Dashboard: Joined supervisor room');
    });
    
    newSocket.on('disconnect', () => {
      console.log('🔌 Supervisor Dashboard: Socket disconnected');
    });
    
    // ✨ Listen for agent status changes (correct event names)
    newSocket.on('agent-status-change', (data: any) => {
      console.log('🔄 Supervisor Dashboard: Agent status changed:', data);
      // Update agent data in real-time
      if (data.agentId) {
        setAgentsData(prevAgents => prevAgents.map(agent => {
          if (agent.id === data.agentId || agent.agent?._id === data.agentId) {
            // ✨ Statü değiştiğinde statusStartTime'ı güncelle (yeni statü başlangıcı)
            const newStatusStartTime = data.timestamp ? new Date(data.timestamp) : new Date();
            return {
              ...agent,
              status: data.newStatusName || data.statusName || agent.status,
              statusStartTime: newStatusStartTime, // ✨ Yeni statü başlangıç zamanı
              // ✨ Update new fields from WebSocket
              callDirection: data.callDirection || null,
              queue: data.queueName || agent.queue,
              incomingCalls: data.incomingCalls ?? agent.incomingCalls,
              outgoingCalls: data.outgoingCalls ?? agent.outgoingCalls,
              totalCallDuration: data.totalCallDuration || agent.totalCallDuration,
              agent: {
                ...agent.agent,
                currentStatusId: data.newStatusId ? { name: data.newStatusName } : agent.agent?.currentStatusId
              }
            };
          }
          return agent;
        }));

        // ✨ Status counts'u güncellemek için status data'yı yeniden hesapla
        updateStatusCounts();
      }
    });
    
    // Also listen for agentStatusUpdated event (for compatibility)
    newSocket.on('agentStatusUpdated', (data: any) => {
      console.log('🔄 Supervisor Dashboard: Agent status updated:', data);
      if (data.agentId) {
        // ✨ Real-time update without reloading all data
        setAgentsData(prevAgents => prevAgents.map(agent => {
          if (agent.id === data.agentId || agent.agent?._id === data.agentId) {
            const newStatusStartTime = data.timestamp ? new Date(data.timestamp) : new Date();
            return {
              ...agent,
              status: data.statusName || agent.status,
              statusStartTime: newStatusStartTime,
              // ✨ Update new fields from WebSocket
              callDirection: data.callDirection || null,
              queue: data.queueName || agent.queue,
              incomingCalls: data.incomingCalls ?? agent.incomingCalls,
              outgoingCalls: data.outgoingCalls ?? agent.outgoingCalls,
              totalCallDuration: data.totalCallDuration || agent.totalCallDuration,
              agent: {
                ...agent.agent,
                currentStatusId: data.statusId ? { name: data.statusName } : agent.agent?.currentStatusId
              }
            };
          }
          return agent;
        }));
        updateStatusCounts();
      }
    });

    // ✨ Listen for agent queue changes
    newSocket.on('agent-queue-changed', (data: any) => {
      console.log('🔄 Supervisor Dashboard: Agent queue changed:', data);
      if (data.agentId) {
        setAgentsData(prevAgents => prevAgents.map(agent => {
          if (agent.id === data.agentId || agent.agent?._id === data.agentId) {
            return {
              ...agent,
              queue: data.queueName || '-'
            };
          }
          return agent;
        }));
      }
    });

    // ✨ Listen for incoming calls
    newSocket.on('incoming-call', (data: any) => {
      console.log('📞 Supervisor Dashboard: Incoming call:', data);
      // Kuyruksuz çağrıları ekleme
      if (!data.queueId) return;
      // Add to active calls
      setActiveCalls(prevCalls => [...prevCalls, {
        _id: data.callId,
        callerNumber: data.callerNumber,
        callerName: data.callerName,
        queueId: data.queueId,
        status: 'waiting',
        startTime: data.timestamp
      }]);
    });

    // ✨ Listen for new messages (supervisor sees all)
    newSocket.on('new-message', (data: any) => {
      console.log('💬 Supervisor: New message detected:', data);
      // Reload conversations if on messages tab
      if (activeSection === 'messages') {
        loadSupervisorConversations();
        
        // If viewing this conversation, add message immediately
        if (selectedConversation) {
          const user1 = selectedConversation.lastMessage?.senderId?._id;
          const user2 = selectedConversation.lastMessage?.receiverId?._id;
          if (user1 && user2 && 
              (data.senderId === user1 || data.senderId === user2 || 
               data.receiverId === user1 || data.receiverId === user2)) {
            // Add message to current conversation immediately
            setMessages(prev => {
              // Check if message already exists (avoid duplicates)
              if (prev.some(msg => msg._id === data.messageId)) {
                return prev;
              }
              // Add new message
              return [...prev, {
                _id: data.messageId,
                senderId: { _id: data.senderId },
                receiverId: { _id: data.receiverId },
                content: data.content,
                isRead: false,
                createdAt: new Date().toISOString()
              }];
            });
          }
        }
      }
    });

    // ✨ Listen for call answered
    newSocket.on('call-answered', (data: any) => {
      console.log('📞 Supervisor Dashboard: Call answered:', data);
      // Update active calls - extract ID from agentId if it's an object
      const agentId = typeof data.agentId === 'object' ? data.agentId._id : data.agentId;
      setActiveCalls(prevCalls => prevCalls.map(call =>
        call._id === data.callId ? { 
          ...call, 
          status: 'answered', 
          agentId: agentId,
          agentChannel: data.agentChannel,
          agentExtension: data.agentExtension 
        } : call
      ));

      // Reload agent data to update statistics
      void loadData();
    });

    // ✨ Listen for call ended
    newSocket.on('call-ended', (data: any) => {
      console.log('📞 Supervisor Dashboard: Call ended:', data);
      // Remove from active calls
      setActiveCalls(prevCalls => prevCalls.filter(call => call._id !== data?.callId && call.id !== data?.callId));
    });

    // ✨ Listen for call status updates
    newSocket.on('call-status-update', (data: any) => {
      console.log('📞 Supervisor Dashboard: Call status update:', data);
      if (data.status === 'ended') {
        setActiveCalls(prevCalls => prevCalls.filter(call => call._id !== data.callId));
      } else {
        // Extract agent ID if it's an object
        const agentId = data.agentId ? (typeof data.agentId === 'object' ? data.agentId._id : data.agentId) : undefined;
        setActiveCalls(prevCalls => prevCalls.map(call =>
          call._id === data.callId ? { 
            ...call, 
            status: data.status,
            ...(agentId && { agentId }),
            ...(data.agentChannel && { agentChannel: data.agentChannel }),
            ...(data.agentExtension && { agentExtension: data.agentExtension })
          } : call
        ));
      }
    });
    
    // ✨ Listen for incoming calls - update active calls list
    newSocket.on('incoming-call', (data: any) => {
      console.log('📞 Supervisor Dashboard: New incoming call:', data);
      // Kuyruksuz çağrıları ekleme
      if (!data.queueId) return;
      // Add to active calls if not already present
      setActiveCalls(prevCalls => {
        const exists = prevCalls.some(call => call._id === data.callId || call.id === data.callId);
        if (!exists && data.callId) {
          return [...prevCalls, {
            _id: data.callId,
            callerNumber: data.callerNumber,
            calledNumber: data.calledNumber,
            status: 'ringing',
            direction: 'incoming',
            startTime: new Date().toISOString(),
            queueId: data.queueId,
            agentId: data.agentId
          }];
        }
        return prevCalls;
      });
    });
    
    // ✨ Listen for call answered
    newSocket.on('call-answered', (data: any) => {
      console.log('📞 Supervisor Dashboard: Call answered:', data);
      setActiveCalls(prevCalls => prevCalls.map(call =>
        (call._id === data?.callId || call.id === data?.callId) 
          ? { ...call, status: 'answered', answerTime: new Date().toISOString() } 
          : call
      ));
    });
    
    // Refresh data every 30 seconds
    const refreshInterval = setInterval(() => {
      void loadData();
    }, 30000);
    
    // ✨ Duration updates are now handled by CallDurationTimer component
    // Removed durationUpdateInterval to prevent unnecessary re-renders
    
    return () => {
      clearInterval(refreshInterval);
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, [navigate]);

  const totalAgents = statusData.reduce((sum, status) => sum + status.count, 0);

  if (loading && agentsData.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f8fafc",
        fontFamily: "'Axiforma', 'Monaco', 'Menlo', 'Ubuntu Mono', monospace",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)",
          zIndex: -1,
        },
      }}
    >
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        {/* Sidebar */}
        <audio 
        id="remoteAudio" 
        autoPlay 
        playsInline
        style={{ display: 'none' }} 
        onLoadedMetadata={() => console.log('🔊 Remote audio loaded')}
        onError={(e) => console.error('❌ Remote audio error:', e)}
        onPlay={() => console.log('▶️ Remote audio started playing')}
        onPause={() => console.log('⏸️ Remote audio paused')}
        onCanPlay={() => console.log('🎵 Remote audio can play')}
        onLoadStart={() => console.log('🔄 Remote audio load started')}
        onVolumeChange={(e) => console.log('🔊 Volume:', (e.target as HTMLAudioElement).volume)}
      />
      
      {/* Additional audio elements from agent-p */}
      <audio autoPlay></audio>
      <audio autoPlay></audio>
        <Box
          sx={{
            width: "100px",
            bgcolor: "#1e3a8a",
            backdropFilter: "blur(10px)",
            boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
            borderRight: "1px solid rgba(255, 255, 255, 0.1)",
            py: 2,
            px: 1.5,
            display: "flex",
            flexDirection: "column",
            position: "sticky",
            top: 0,
            height: "100vh",
          }}
        >
          {/* Logo */}
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center', py: { xs: 2, sm: 3 } }}>
            <Box
              component="img"
              src="/percrm-logo.svg"
              alt="PerCRM"
              sx={{
                width: '70px',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
          </Box>

          <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "stretch", gap: 2, mt: 2, px: 1 }}>
              <Box onClick={() => setActiveSection('dashboard')} sx={{ cursor: 'pointer', width: '100%' }}>
                <NavItem icon={<IconUsers size={32} color={activeSection==='dashboard' ? '#ffffff' : '#e5e7eb'} />} label="Dashboard" />
              </Box>
              <Box onClick={() => setActiveSection('calls')} sx={{ cursor: 'pointer', width: '100%' }}>
                <NavItem icon={<IconHeadset size={32} color={activeSection==='calls' ? '#ffffff' : '#e5e7eb'} />} label="Çağrılar" />
              </Box>
              <Box onClick={() => setActiveSection('reports')} sx={{ cursor: 'pointer', width: '100%' }}>
                <NavItem icon={<IconPercentage size={32} color={activeSection==='reports' ? '#ffffff' : '#e5e7eb'} />} label="Raporlar" />
              </Box>
              <Box onClick={() => setActiveSection('support')} sx={{ cursor: 'pointer', width: '100%' }}>
                <NavItem icon={<IconHelp size={32} color={activeSection==='support' ? '#ffffff' : '#e5e7eb'} />} label="Destek" />
              </Box>
              <Box onClick={() => setActiveSection('messages')} sx={{ cursor: 'pointer', width: '100%' }}>
                <NavItem icon={<IconSend size={32} color={activeSection==='messages' ? '#ffffff' : '#e5e7eb'} />} label="Mesajlar" />
              </Box>
              <Box onClick={() => setActiveSection('campaigns')} sx={{ cursor: 'pointer', width: '100%' }}>
                <NavItem icon={<IconSpeakerphone size={32} color={activeSection==='campaigns' ? '#ffffff' : '#e5e7eb'} />} label="Dialer" />
              </Box>
            </Box>
            {/* Snackbar for messages */}
            <Snackbar
              open={snackbar.open}
              onClose={closeSnackbar}
              autoHideDuration={6000}
            >
              <Alert onClose={closeSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                {snackbar.message}
              </Alert>
            </Snackbar>

            {/* Profile Section - Bottom Left with menu opening to right */}
            <Box 
              className="profile-menu-container"
              sx={{ 
                position: "absolute", 
                bottom: 20, 
                left: "50%", 
                transform: "translateX(-50%)", 
                display: "flex", 
                flexDirection: "column", 
                alignItems: "center", 
                gap: 1,
                cursor: "pointer"
              }}
              onClick={() => setShowProfileMenu(!showProfileMenu)}
            >
              <Box sx={{ 
                width: 40, 
                height: 40, 
                borderRadius: "50%", 
                bgcolor: "#f59e0b", 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                color: "white",
                fontWeight: "bold"
              }}>
                {currentUser?.firstName?.charAt(0) || 'S'}{currentUser?.lastName?.charAt(0) || 'D'}
              </Box>
              <Typography variant="caption" sx={{ color: "white", textAlign: "center", fontSize: "0.6rem", fontWeight: 500 }}>
                {currentUser?.firstName || 'Supervisor'} {currentUser?.lastName || 'Dashboard'}
              </Typography>
              <IconDotsVertical size={16} color="rgba(255, 255, 255, 0.6)" />
              
              {/* Profile Menu - Opens to the RIGHT */}
              {showProfileMenu && (
                <Box sx={{
                  position: "absolute",
                  bottom: 0,
                  left: "calc(100% + 12px)",
                  bgcolor: "white",
                  borderRadius: 2,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                  minWidth: 180,
                  overflow: "hidden",
                  zIndex: 1000
                }}>
                  <Box
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate('/');
                      setShowProfileMenu(false);
                    }}
                    sx={{
                      px: 2,
                      py: 1.5,
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                      "&:hover": {
                        bgcolor: "#f3f4f6"
                      }
                    }}
                  >
                    <IconUsers size={18} color="#374151" />
                    <Typography variant="body2" sx={{ color: "#374151", fontWeight: 500 }}>
                      Ana Menü
                    </Typography>
                  </Box>
                  <Box
                    onClick={async (e) => {
                      e.stopPropagation();
                      try {
                        console.log('🔐 Logout attempt');
                        await authService.logout();
                        console.log('✅ Logout successful');
                        localStorage.clear();
                        window.location.href = '/login';
                      } catch (error) {
                        console.error('❌ Logout error:', error);
                        localStorage.clear();
                        window.location.href = '/login';
                      }
                      setShowProfileMenu(false);
                    }}
                    sx={{
                      px: 2,
                      py: 1.5,
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      cursor: "pointer",
                      borderTop: "1px solid #e5e7eb",
                      transition: "background-color 0.2s",
                      "&:hover": {
                        bgcolor: "#fef2f2"
                      }
                    }}
                  >
                    <IconX size={18} color="#ef4444" />
                    <Typography variant="body2" sx={{ color: "#ef4444", fontWeight: 500 }}>
                      Çıkış Yap
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>

        {/* Main Content */}
        <Box sx={{
          flexGrow: 1,
          p: 3,
          pb: 2,
          overflowY: 'auto',
          height: '100vh',
          // Tüm tipografi Arial, başlık renkleri #152b69
          fontFamily: 'Arial, Helvetica, sans-serif',
          '& .MuiTypography-root': { fontFamily: 'Arial, Helvetica, sans-serif' },
          '& .MuiTypography-h1, & .MuiTypography-h2, & .MuiTypography-h3, & .MuiTypography-h4, & .MuiTypography-h5, & .MuiTypography-h6': {
            color: '#152b69 !important',
            fontFamily: 'Arial, Helvetica, sans-serif'
          }
        }}>
          {/* Header */}
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
            <Box
              sx={{
                width: '100%',
                bgcolor: 'white',
                borderRadius: 3,
                px: { xs: 2, sm: 4 },
                py: { xs: 2, sm: 3 },
                boxShadow: '0 8px 30px rgba(0, 0, 0, 0.06)',
                border: '1px solid rgba(0,0,0,0.06)',
                textAlign: 'center'
              }}
            >
              <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 0.5, fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' } }}>
                Çağrı Merkezi Paneli
              </Typography>
              <Typography variant="h5" sx={{ fontSize: { xs: '0.95rem', sm: '1.05rem', md: '1.1rem' }, color: '#64748b' }}>
                Gerçek zamanlı veriler ve performans metrikleri
              </Typography>
            </Box>
          </Box>

          {/* Call Monitoring Indicator */}
          {isMonitoring && monitoringAgent && (
            <Box sx={{ 
              mb: 2, 
              bgcolor: '#dbeafe', 
              borderRadius: 2, 
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              boxShadow: '0 2px 8px rgba(59, 130, 246, 0.2)',
              border: '1px solid #3b82f6'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{
                  width: 12,
                  height: 12,
                  bgcolor: '#ef4444',
                  borderRadius: '50%',
                  animation: `${pulse} 2s ease-in-out infinite`
                }} />
                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e40af' }}>
                  🎧 Dinleme Aktif: {monitoringAgent.name}
                </Typography>
              </Box>
              <Button
                variant="contained"
                size="small"
                onClick={handleStopMonitoring}
                sx={{
                  bgcolor: '#ef4444',
                  '&:hover': { bgcolor: '#dc2626' }
                }}
              >
                Dinlemeyi Durdur
              </Button>
            </Box>
          )}

          {activeSection === 'dashboard' && (
          /* Stats Cards */
          <Grid container spacing={3} sx={{ mb: 3 }}>
            {/* Overview Chart */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Card sx={{ height: "350px", borderRadius: 3, boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)", border: "1px solid rgba(0, 0, 0, 0.05)" }}>
                <CardContent sx={{ p: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, color: "#374151" }}>
                    Agent Durumu
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: "240px", gap: 3 }}>
                    {/* Donut Chart - Dynamic - Sol taraf */}
                    <Box sx={{ position: "relative", width: 160, height: 160, flexShrink: 0 }}>
                      <Box
                        sx={{
                          width: 160,
                          height: 160,
                          borderRadius: "50%",
                          background: (() => {
                            if (statusData.length === 0 || totalAgents === 0) {
                              return 'conic-gradient(#e5e7eb 0deg 360deg)';
                            }

                            // Build conic gradient dynamically from all statuses
                            let gradientParts: string[] = [];
                            let currentAngle = 0;

                            statusData.forEach((status, index) => {
                              const angle = (status.count / totalAgents) * 360;
                              const startAngle = currentAngle;
                              const endAngle = currentAngle + angle;

                              gradientParts.push(`${status.color} ${startAngle}deg ${endAngle}deg`);
                              currentAngle = endAngle;
                            });

                            // Fill remaining space if needed
                            if (currentAngle < 360) {
                              gradientParts.push(`#e5e7eb ${currentAngle}deg 360deg`);
                            }

                            return `conic-gradient(${gradientParts.join(', ')})`;
                          })(),
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.15)",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            width: "140px",
                            height: "140px",
                            borderRadius: "50%",
                            backgroundColor: "white",
                            zIndex: 1,
                          }
                        }}
                      >
                        <Box sx={{ 
                          position: "relative", 
                          zIndex: 2, 
                          textAlign: "center",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: "-40px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            background: "radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 50%, rgba(255,255,255,0.3) 100%)",
                            boxShadow: "0 0 15px rgba(255, 255, 255, 0.8)",
                            filter: "blur(0.5px)",
                          }
                        }}>
                          <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1e3a8a", textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
                            TOPLAM
                          </Typography>
                          <Typography variant="h3" sx={{ fontWeight: "bold", color: "#1e3a8a", textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", letterSpacing: "2px" }}>
                            {totalAgents}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Legend - Sağ taraf, alt alta */}
                    <Box sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1.5,
                      justifyContent: "center",
                      flex: 1
                    }}>
                      {statusData.map((status, index) => (
                        <Box key={index} sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          p: 1.5,
                          borderRadius: 2,
                          bgcolor: "rgba(255, 255, 255, 0.7)",
                          backdropFilter: "blur(10px)",
                          border: "1px solid rgba(255, 255, 255, 0.2)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "translateX(5px)",
                            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
                          }
                        }}>
                          <Box sx={{
                            width: "14px",
                            height: "14px",
                            borderRadius: "50%",
                            bgcolor: status.color,
                            boxShadow: `0 2px 8px ${status.color}50`,
                            background: `radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.8), ${status.color})`,
                            flexShrink: 0
                          }} />
                          <Typography variant="body2" sx={{ fontWeight: 600, color: "#374151", flex: 1 }}>
                            {status.label}
                          </Typography>
                          <Typography variant="body2" sx={{ fontWeight: 700, color: status.color }}>
                            {status.count}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Tables */}
            <Grid size={{ xs: 12, md: 8 }}>
              <Card sx={{ height: "350px", borderRadius: 3, boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)", border: "1px solid rgba(0, 0, 0, 0.05)" }}>
                <CardContent sx={{ p: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, color: "#374151" }}>
                      Temsilci ve Statü Tablosu
                  </Typography>

                  <Box sx={{ maxHeight: "280px", overflow: "auto" }}>
                    <TableContainer>
                      <Table size="small">
                        <TableHead sx={{ bgcolor: "#f8fafc" }}>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 900, color: "#374151", fontSize: "0.75rem" }}>Agent</TableCell>
                            <TableCell sx={{ fontWeight: 900, color: "#374151", fontSize: "0.75rem" }}>Durum</TableCell>
                            <TableCell sx={{ fontWeight: 900, color: "#374151", fontSize: "0.75rem" }}>Süresi</TableCell>
                            <TableCell sx={{ fontWeight: 900, color: "#374151", fontSize: "0.75rem" }}>Kuyruk</TableCell>
                            <TableCell sx={{ fontWeight: 900, color: "#374151", fontSize: "0.75rem" }}>Çağrı Yönü</TableCell>
                            <TableCell sx={{ fontWeight: 900, color: "#374151", fontSize: "0.75rem" }}>Gelen Arama</TableCell>
                            <TableCell sx={{ fontWeight: 900, color: "#374151", fontSize: "0.75rem" }}>Giden Arama</TableCell>
                            <TableCell sx={{ fontWeight: 900, color: "#374151", fontSize: "0.75rem" }}>Toplam Arama</TableCell>
                          </TableRow>
                        </TableHead>
                          <TableBody>
                            {agentsData.map((agent) => (
                              <TableRow
                                key={agent.id}
                                hover
                                sx={{
                                  cursor: "default",
                                  transition: "all 0.2s ease",
                                  "&:hover": {
                                    bgcolor: "#f0f9ff",
                                    transform: "translateY(-1px)",
                                    boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
                                  },
                                  "&:nth-of-type(even)": { bgcolor: "#f8fafc" },
                                  borderBottom: "1px solid #e5e7eb"
                                }}
                              >
                                <TableCell sx={{ fontWeight: 500, color: "#374151", fontSize: "0.8rem" }}>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    {/* Üç nokta menü butonu - isim ve avatarın solunda */}
                                    <IconButton
                                      size="small"
                                      onClick={(e) => openAgentMenu(e, agent)}
                                      sx={{ mr: 0.5 }}
                                      aria-label="Ajan menüsü"
                                    >
                                      <IconDotsVertical size={18} />
                                    </IconButton>
                                    <Avatar sx={{
                                      width: 28,
                                      height: 28,
                                      fontSize: "0.7rem",
                                      bgcolor: getStatusColor(agent.status)
                                    }}>
                                      {agent.avatar}
                                    </Avatar>
                                    {agent.name}
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    label={agent.status}
                                    size="small"
                                    sx={{
                                      bgcolor: getStatusColor(agent.status),
                                      color: "white",
                                      fontSize: "0.7rem",
                                      fontWeight: 600,
                                      borderRadius: 1,
                                      boxShadow: `0 2px 8px ${getStatusColor(agent.status)}40`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell sx={{ fontWeight: 500, color: "#6b7280", fontSize: "0.8rem" }}>
                                  <CallDurationTimer startTime={agent.statusStartTime} />
                                </TableCell>
                                <TableCell sx={{ fontWeight: 500, color: "#6b7280", fontSize: "0.8rem" }}>
                                  {agent.queue || '-'}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 500, color: "#6b7280", fontSize: "0.8rem" }}>
                                  {agent.callDirection || '-'}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 500, color: "#3b82f6", fontSize: "0.8rem" }}>
                                  {agent.incomingCalls || 0}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 500, color: "#8b5cf6", fontSize: "0.8rem" }}>
                                  {agent.outgoingCalls || 0}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 500, color: "#10b981", fontSize: "0.8rem" }}>
                                  {(agent.incomingCalls || 0) + (agent.outgoingCalls || 0)}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          )}

          {/* Ajan satır menüsü */}
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={closeAgentMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          
          >
            <MenuItem
              onClick={() => {
                console.log('🔍 MT Performansı clicked, menuAgent:', menuAgent);
                if (menuAgent) {
                  closeAgentMenu();
                  handleAgentClick(menuAgent);
                } else {
                  console.error('❌ menuAgent is null/undefined');
                  closeAgentMenu();
                }
              }}
            >
              MT Performansı
            </MenuItem>
            <MenuItem
              onClick={() => {
                if (menuAgent) {
                  handleOpenStatusChangeDialog(menuAgent);
                }
              }}
            >
              Statü Değiştir
            </MenuItem>
            <MenuItem
              onClick={() => {
                if (menuAgent) {
                  handleStartMonitoring(menuAgent);
                }
              }}
              disabled={!activeCalls.some((call: any) => {
                const match = call.agentId === menuAgent?.id || call.agentExtension === menuAgent?.extension;
                if (!match) {
                  console.log('🔍 No match for call:', { callAgentId: call.agentId, callExtension: call.agentExtension, menuAgentId: menuAgent?.id, menuAgentExtension: menuAgent?.extension });
                }
                return match;
              })}
            >
              Çağrıyı Dinle
            </MenuItem>
            <MenuItem
              onClick={() => {
                if (menuAgent) {
                  handleStartMonitoringF(menuAgent);
                }
              }}
              disabled={!activeCalls.some((call: any) => {
                const match = call.agentId === menuAgent?.id || call.agentExtension === menuAgent?.extension;
                if (!match) {
                  console.log('🔍 No match for call:', { callAgentId: call.agentId, callExtension: call.agentExtension, menuAgentId: menuAgent?.id, menuAgentExtension: menuAgent?.extension });
                }
                return match;
              })}
            >
              Fısılda 
            </MenuItem>
          </Menu>

          {/* Statü Değiştirme Dialog'u */}
          <Dialog 
            open={statusChangeDialogOpen} 
            onClose={handleCloseStatusChangeDialog}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle sx={{ bgcolor: '#F9FAFB', borderBottom: '1px solid #E5E7EB' }}>
              Statü Değiştir - {statusChangeAgent?.name}
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
              <FormControl fullWidth>
                <InputLabel>Yeni Statü</InputLabel>
                <Select
                  value={selectedStatusId}
                  onChange={(e) => setSelectedStatusId(e.target.value)}
                  label="Yeni Statü"
                >
                  {agentStatusContext.statuses.map((status: any) => (
                    <MenuItem key={status._id} value={status._id}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box 
                          sx={{ 
                            width: 12, 
                            height: 12, 
                            borderRadius: '50%', 
                            bgcolor: status.color 
                          }} 
                        />
                        {status.name}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions sx={{ p: 2, bgcolor: '#F9FAFB' }}>
              <Button onClick={handleCloseStatusChangeDialog} color="inherit">
                İptal
              </Button>
              <Button 
                onClick={handleChangeAgentStatus} 
                variant="contained"
                sx={{ 
                  bgcolor: '#4F46E5',
                  '&:hover': { bgcolor: '#4338CA' }
                }}
              >
                Değiştir
              </Button>
            </DialogActions>
          </Dialog>

          {activeSection === 'dashboard' && (
          /* ✨ Active Calls and Queue Statistics Section - Swapped order */
          <Grid container spacing={3} sx={{ mt: 1 }}>
            {/* Anlık Çağrılar - Moved to first position */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Card sx={{ height: "350px", borderRadius: 3, boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)", border: "1px solid rgba(0, 0, 0, 0.05)" }}>
                <CardContent sx={{ p: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, color: "#374151" }}>
                    Anlık Çağrılar
                  </Typography>
                  {activeCalls.length > 0 ? (
                    <TableContainer sx={{ maxHeight: "280px", overflow: "auto" }}>
                      <Table size="small">
                        <TableHead sx={{ bgcolor: "#f8fafc" }}>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600, color: "#374151", fontSize: "0.75rem" }}>Arayan</TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "#374151", fontSize: "0.75rem" }}>Temsilci</TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "#374151", fontSize: "0.75rem" }}>Kuyruk</TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "#374151", fontSize: "0.75rem" }}>Durum</TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "#374151", fontSize: "0.75rem" }}>Süre</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {activeCalls.map((call: any) => {
                            const getStatusLabel = (status: string) => {
                              switch(status) {
                                case 'ringing': return 'Çalıyor';
                                case 'answered': return 'Yanıtlandı';
                                case 'waiting': return 'Bekliyor';
                                default: return status || 'Bilinmiyor';
                              }
                            };
                            
                            const getStatusColor = (status: string) => {
                              switch(status) {
                                case 'ringing': return '#f59e0b';
                                case 'answered': return '#10b981';
                                case 'waiting': return '#3b82f6';
                                default: return '#6b7280';
                              }
                            };
                            
                            return (
                              <TableRow
                                key={call._id || call.id}
                                sx={{
                                  transition: "all 0.2s ease",
                                  "&:hover": {
                                    bgcolor: "#f0f9ff",
                                    transform: "translateY(-1px)",
                                  },
                                  "&:nth-of-type(even)": { bgcolor: "#f8fafc" },
                                  borderBottom: "1px solid #e5e7eb"
                                }}
                              >
                                <TableCell sx={{ fontWeight: 500, color: "#374151", fontSize: "0.8rem" }}>
                                  {/* Arayan/Müşteri numarası: gelen çağrıda callerNumber, giden çağrıda calledNumber */}
                                  {call?.direction === 'outgoing' ? (call.calledNumber || '-') : (call.callerNumber || '-')}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 500, color: "#374151", fontSize: "0.8rem" }}>
                                  {call.agentId
                                    ? (typeof call.agentId === 'object'
                                      ? `${call.agentId.firstName || ''} ${call.agentId.lastName || ''}`.trim() || call.agentId.email || '-'
                                      : '-')
                                    : '-'}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 500, color: "#374151", fontSize: "0.8rem" }}>
                                  {call.queueId
                                    ? (typeof call.queueId === 'object'
                                      ? call.queueId.name || '-'
                                      : '-')
                                    : '-'}
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    label={getStatusLabel(call.status)}
                                    size="small"
                                    sx={{
                                      bgcolor: getStatusColor(call.status),
                                      color: "white",
                                      fontSize: "0.7rem",
                                      fontWeight: 600,
                                      borderRadius: 1,
                                    }}
                                  />
                                </TableCell>
                                <TableCell sx={{ fontWeight: 500, color: "#10b981", fontSize: "0.8rem" }}>
                                  <CallDurationTimer startTime={call.startTime} answerTime={call.answerTime} />
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Box sx={{ textAlign: "center", py: 4 }}>
                      <Typography variant="body2" sx={{ color: "#6b7280" }}>
                        Şu anda aktif çağrı bulunmuyor
                      </Typography>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Kuyruk İstatistikleri - Moved to second position */}
            <Grid size={{ xs: 12, md: 8 }}>
              <Card sx={{ height: "350px", borderRadius: 3, boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)", border: "1px solid rgba(0, 0, 0, 0.05)" }}>
                <CardContent sx={{ p: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, color: "#374151" }}>
                    Kuyruk İstatistikleri
                  </Typography>
                  <TableContainer sx={{ maxHeight: "280px", overflow: "auto" }}>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600, color: "#374151", bgcolor: "#f8fafc", fontSize: "0.75rem" }}>Kuyruk Adı</TableCell>
                          <TableCell sx={{ fontWeight: 600, color: "#374151", bgcolor: "#f8fafc", fontSize: "0.75rem" }}>Toplam Arama</TableCell>
                          <TableCell sx={{ fontWeight: 600, color: "#374151", bgcolor: "#f8fafc", fontSize: "0.75rem" }}>Giden Arama</TableCell>
                          <TableCell sx={{ fontWeight: 600, color: "#374151", bgcolor: "#f8fafc", fontSize: "0.75rem" }}>Gelen Arama</TableCell>
                          <TableCell sx={{ fontWeight: 600, color: "#374151", bgcolor: "#f8fafc", fontSize: "0.75rem" }}>Kaçan Çağrı</TableCell>

                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {queueData.map((queue, index) => {
                          const stats = queue.queue?.statistics || {};
                          const totalCalls = stats.totalCalls || 0;
                          const incomingCalls = stats.incomingCalls || 0;
                          const outgoingCalls = stats.outgoingCalls || 0;
                          const answeredCalls = stats.answeredCalls || 0;
                          const missedCalls = stats.missedCalls || 0;
                          const avgAnsweredDuration = stats.avgAnsweredDuration || 0;
                          const _successRate = stats.successRate || 0;

                          return (
                            <TableRow key={index} sx={{
                              transition: "all 0.2s ease",
                              "&:hover": {
                                bgcolor: "#f0f9ff",
                                transform: "translateY(-1px)",
                                boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
                              },
                              "&:nth-of-type(even)": { bgcolor: "#f8fafc" },
                              borderBottom: "1px solid #e5e7eb"
                            }}>
                              <TableCell sx={{ fontWeight: 500, color: "#374151", fontSize: "0.8rem" }}>
                                  <Chip
                                      label={queue.name}
                                      size="small"
                                      sx={{
                                          bgcolor: "#152b69",
                                          color: "white",
                                          fontSize: "0.7rem",
                                          fontWeight: 600,
                                          borderRadius: 1,
                                      }}
                                  /></TableCell>
                              <TableCell sx={{ fontWeight: 500, color: "#6b7280", fontSize: "0.8rem" }}>{totalCalls}</TableCell>
                              <TableCell sx={{ fontWeight: 500, color: "#3b82f6", fontSize: "0.8rem" }}>{outgoingCalls}</TableCell>
                              <TableCell sx={{ fontWeight: 500, color: "#8b5cf6", fontSize: "0.8rem" }}>{incomingCalls}</TableCell>
                              <TableCell sx={{ fontWeight: 500, color: "#10b981", fontSize: "0.8rem" }}>{missedCalls}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          )}

          {/* Çağrılar Sekmesi */}
          {activeSection === 'calls' && (
            <Box>
              {/* Filtreleme Paneli */}
              <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', border: '1px solid rgba(0,0,0,0.05)', mb: 3, bgcolor: '#f8fafc' }}>
                <CardContent sx={{ p: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#152b69' }}>
                    🔍 Filtreleme
                  </Typography>
                  <Grid container spacing={2}>
                    {/* Çağrı Yönü Filtresi */}
                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                      <Box>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
                          Çağrı Yönü
                        </Typography>
                        <Select
                          size="small"
                          value={callsFilterDirection}
                          onChange={(e) => {
                            setCallsFilterDirection(e.target.value);
                            setCallsPage(1);
                          }}
                          sx={{ width: '100%', bgcolor: 'white' }}
                        >
                          <MenuItem value="all">Tümü</MenuItem>
                          <MenuItem value="incoming">Gelen</MenuItem>
                          <MenuItem value="outgoing">Giden</MenuItem>
                        </Select>
                      </Box>
                    </Grid>

                    {/* Durum Filtresi */}
                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                      <Box>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
                          Durum
                        </Typography>
                        <Select
                          size="small"
                          value={callsFilterStatus}
                          onChange={(e) => {
                            setCallsFilterStatus(e.target.value);
                            setCallsPage(1);
                          }}
                          sx={{ width: '100%', bgcolor: 'white' }}
                        >
                          <MenuItem value="all">Tümü</MenuItem>
                          <MenuItem value="ended">Tamamlandı</MenuItem>
                          <MenuItem value="completed">Tamamlandı</MenuItem>
                          <MenuItem value="answered">Yanıtlandı</MenuItem>
                          <MenuItem value="ringing">Çalıyor</MenuItem>
                          <MenuItem value="waiting">Bekliyor</MenuItem>
                          <MenuItem value="missed">Kaçırıldı</MenuItem>
                          <MenuItem value="failed">Başarısız</MenuItem>
                          <MenuItem value="rejected">Reddedildi</MenuItem>
                          <MenuItem value="cancelled">İptal Edildi</MenuItem>
                          <MenuItem value="no-answer">Cevap Yok</MenuItem>
                          <MenuItem value="busy">Meşgul</MenuItem>
                          <MenuItem value="unavailable">Kullanılamaz</MenuItem>
                          <MenuItem value="initiated">Başlatıldı</MenuItem>
                          <MenuItem value="active">Aktif</MenuItem>
                          <MenuItem value="held">Beklemede</MenuItem>
                          <MenuItem value="transferred">Transfer Edildi</MenuItem>
                        </Select>
                      </Box>
                    </Grid>

                    {/* Temsilci Filtresi */}
                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                      <Box>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
                          Temsilci
                        </Typography>
                        <Select
                          size="small"
                          value={callsFilterAgent}
                          onChange={(e) => {
                            setCallsFilterAgent(e.target.value);
                            setCallsPage(1);
                          }}
                          sx={{ width: '100%', bgcolor: 'white' }}
                        >
                          <MenuItem value="">Tümü</MenuItem>
                          {allAgents
                            .map((agent: any) => ({
                              id: agent._id,
                              name: `${agent.firstName || ''} ${agent.lastName || ''}`.trim() || agent.email || '-'
                            }))
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((agent: any) => (
                              <MenuItem key={agent.id} value={agent.name}>{agent.name}</MenuItem>
                            ))}
                        </Select>
                      </Box>
                    </Grid>

                    {/* Kuyruk Filtresi */}
                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                      <Box>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
                          Kuyruk
                        </Typography>
                        <Select
                          size="small"
                          value={callsFilterQueue}
                          onChange={(e) => {
                            setCallsFilterQueue(e.target.value);
                            setCallsPage(1);
                          }}
                          sx={{ width: '100%', bgcolor: 'white' }}
                        >
                          <MenuItem value="">Tümü</MenuItem>
                          {allQueues
                            .map((queue: any) => ({
                              id: queue._id || queue.id,
                              name: queue.name || queue.queueName || '-'
                            }))
                            .filter((queue: any) => queue.name !== '-')
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((queue: any) => (
                              <MenuItem key={queue.id} value={queue.name}>{queue.name}</MenuItem>
                            ))}
                        </Select>
                      </Box>
                    </Grid>

                    {/* Telefon Filtresi */}
                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                      <Box>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
                          Telefon
                        </Typography>
                        <Box
                          component="input"
                          type="text"
                          placeholder="Telefon ara..."
                          value={callsFilterPhone}
                          onChange={(e) => {
                            setCallsFilterPhone(e.target.value);
                            setCallsPage(1);
                          }}
                          sx={{
                            width: '100%',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            border: '1px solid #e5e7eb',
                            fontSize: '0.875rem',
                            fontFamily: 'inherit',
                            '&:focus': {
                              outline: 'none',
                              borderColor: '#3b82f6',
                              boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)'
                            }
                          }}
                        />
                      </Box>
                    </Grid>

                    {/* Başlangıç Tarihi Filtresi */}
                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                      <Box>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
                          Başlangıç Tarihi
                        </Typography>
                        <Box
                          component="input"
                          type="date"
                          value={callsFilterStartDate}
                          onChange={(e) => {
                            setCallsFilterStartDate(e.target.value);
                            setCallsPage(1);
                          }}
                          sx={{
                            width: '100%',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            border: '1px solid #e5e7eb',
                            fontSize: '0.875rem',
                            fontFamily: 'inherit',
                            '&:focus': {
                              outline: 'none',
                              borderColor: '#3b82f6',
                              boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)'
                            }
                          }}
                        />
                      </Box>
                    </Grid>

                    {/* Bitiş Tarihi Filtresi */}
                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                      <Box>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
                          Bitiş Tarihi
                        </Typography>
                        <Box
                          component="input"
                          type="date"
                          value={callsFilterEndDate}
                          onChange={(e) => {
                            setCallsFilterEndDate(e.target.value);
                            setCallsPage(1);
                          }}
                          sx={{
                            width: '100%',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            border: '1px solid #e5e7eb',
                            fontSize: '0.875rem',
                            fontFamily: 'inherit',
                            '&:focus': {
                              outline: 'none',
                              borderColor: '#3b82f6',
                              boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)'
                            }
                          }}
                        />
                      </Box>
                    </Grid>

                    {/* Finish Code Filtresi */}
                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                      <Box>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
                          Finish Code
                        </Typography>
                        <Select
                          size="small"
                          value={callsFilterFinishCode}
                          onChange={(e) => {
                            setCallsFilterFinishCode(e.target.value);
                            setCallsPage(1);
                          }}
                          sx={{ width: '100%', bgcolor: 'white' }}
                        >
                          <MenuItem value="">Tümü</MenuItem>
                          <MenuItem value="Görüşme Yapıldı">Görüşme Yapıldı</MenuItem>
                          <MenuItem value="Ses Yok">Ses Yok</MenuItem>
                          <MenuItem value="Kara Liste">Kara Liste</MenuItem>
                          <MenuItem value="Numara Kullanılmıyor">Numara Kullanılmıyor</MenuItem>
                          <MenuItem value="Meşgul">Meşgul</MenuItem>
                          <MenuItem value="Ulaşılamadı">Ulaşılamadı</MenuItem>
                        </Select>
                      </Box>
                    </Grid>

                    {/* Temizle Butonu */}
                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'flex-end', height: '100%' }}>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            setCallsFilterDirection('all');
                            setCallsFilterStatus('all');
                            setCallsFilterAgent('');
                            setCallsFilterQueue('');
                            setCallsFilterPhone('');
                            setCallsFilterStartDate('');
                            setCallsFilterEndDate('');
                            setCallsFilterFinishCode('');
                            setCallsPage(1);
                          }}
                          sx={{ width: '100%' }}
                        >
                          Temizle
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              {/* Çağrılar Tablosu */}
              <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', border: '1px solid rgba(0,0,0,0.05)', mb: 3 }}>
                <CardContent sx={{ p: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                    Tüm Çağrılar
                  </Typography>
                  <TableContainer sx={{ maxHeight: '65vh', overflow: 'auto' }}>
                    <Table size="small" stickyHeader>
                      <TableHead sx={{ bgcolor: '#f8fafc' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Tarih/Saat</TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Yön</TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Telefon</TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Müşteri</TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Temsilci</TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Kuyruk</TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Finish Code</TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Süre</TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Kayıt</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {callsLoading ? (
                          <TableRow>
                            <TableCell colSpan={10} align="center">
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
                                <CircularProgress size={24} sx={{ mr: 1.5 }} />
                                <Typography variant="body2" color="text.secondary">Yükleniyor…</Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ) : calls.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                              <Typography variant="body2" color="text.secondary">Kayıt bulunamadı</Typography>
                            </TableCell>
                          </TableRow>
                        ) : (
                          calls.map((c: any) => {
                            const dir = c.direction || '-';
                            const phone = dir === 'outgoing' ? (c.calledNumber || c.callerNumber || '-') : (c.callerNumber || c.calledNumber || '-');
                            // For outgoing calls the customer is the party being called (calledNumber/customerPhone)
                            const customer = c.displayCustomerName || (dir === 'outgoing' ? (c.customerPhone || c.calledNumber || c.callerName || phone) : (c.callerName || c.calledNumber || phone)) || '-';
                            const agentName = c.agentId ? `${c.agentId.firstName || ''} ${c.agentId.lastName || ''}`.trim() : '-';
                            const queueName = c.queueId?.name || '-';
                            const status = c.status || '-';

                            // Durum çevirisi
                            const getStatusTR = (statusEn: string) => {
                              const statusMap: Record<string, string> = {
                                'ended': 'Tamamlandı',
                                'completed': 'Tamamlandı',
                                'failed': 'Başarısız',
                                'pending': 'Beklemede',
                                'ringing': 'Çalıyor',
                                'answered': 'Yanıtlandı',
                                'missed': 'Kaçırıldı',
                                'unanswered': 'Cevapsız',
                                'rejected': 'Reddedildi',
                                'cancelled': 'İptal Edildi',
                                'no-answer': 'Cevap Yok',
                                'busy': 'Meşgul',
                                'unavailable': 'Kullanılamaz',
                                'error': 'Hata',
                                'unknown': 'Bilinmiyor'
                              };
                              return statusMap[statusEn?.toLowerCase()] || statusEn;
                            };
                            
                            const _statusTR = getStatusTR(status);
                            const startTime = c.startTime || c.createdAt;
                            const duration = formatDurationHHMMSS(c.duration);
                            
                            // Finish Code - müşteri kartından tarih bazlı al
                            const finishCode = c.finishCode || '-';
                            
                            return (
                              <TableRow key={c._id} hover sx={{ '&:nth-of-type(even)': { bgcolor: '#f8fafc' } }}>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDateTR(startTime)}</TableCell>
                                <TableCell sx={{ textTransform: 'capitalize' }}>{dir === 'incoming' ? 'Gelen' : (dir === 'outgoing' ? 'Giden' : dir)}</TableCell>
                                <TableCell>{phone}</TableCell>
                                <TableCell>{customer}</TableCell>
                                <TableCell>{agentName || '-'}</TableCell>
                                <TableCell>{queueName}</TableCell>
                               
                                <TableCell sx={{ fontWeight: 500, color: '#6b7280', fontSize: '0.8rem' }}>
                                  {finishCode}
                                </TableCell>
                                <TableCell>{duration}</TableCell>
                                <TableCell>
                                  <Box sx={{ display: 'flex', gap: 1 }}>
                                    { (c.recording && c.recording.hasRecording) && (
                                      <>
                                        <IconButton size="small" onClick={async () => {
                                          try {
                                            // Double-check recording availability via context
                                            let recStatus = callRecordingContext.getRecordingStatus(c._id);
                                            if (!recStatus || !recStatus.recording || !recStatus.recording.hasRecording) {
                                              // Try to fetch recording metadata by callId
                                              console.debug('No recording in context for callId', c._id, '— fetching recordings');
                                              const fetched = await callRecordingContext.fetchRecordings({ callId: c._id, limit: 5 });
                                              console.debug('Fetched recordings for callId', c._id, fetched);
                                              recStatus = callRecordingContext.getRecordingStatus(c._id);
                                            }
                                            if (!recStatus || !recStatus.recording || !recStatus.recording.hasRecording) {
                                              // Fallback: attempt to stream using callId directly
                                              console.debug('Fallback: attempting stream using callId', c._id);
                                              const url = crPlay(c._id);
                                              if (!url) {
                                                showSnackbar('Kayıt bulunamadı', 'warning');
                                                return;
                                              }
                                              try {
                                                const res = await fetch(url, { method: 'HEAD' });
                                                if (!res.ok) {
                                                  showSnackbar('Kayıt akışı bulunamadı (sunucu hatası)', 'warning');
                                                  return;
                                                }
                                              } catch (e) {
                                                console.error('HEAD request for recording failed', e);
                                                // Continue to try to load – in some servers HEAD isn't permitted
                                              }
                                              setPlayerDialog({ open: true, audioUrl: url, title: `${agentName} • ${phone}` });
                                              return;
                                            }
                                            const url = crPlay(c._id);
                                            if (url) setPlayerDialog({ open: true, audioUrl: url, title: `${agentName} • ${phone}` });
                                          } catch (e) {
                                            console.error('Play error', e);
                                            showSnackbar('Kayıt oynatılırken hata oluştu', 'error');
                                          }
                                        }} title="Dinle">
                                          <IconPlayerPlay size={16} />
                                        </IconButton>

                                        <IconButton size="small" onClick={async () => {
                                          // Double-check before starting download
                                          let recStatus = callRecordingContext.getRecordingStatus(c._id);
                                          if (!recStatus || !recStatus.recording || !recStatus.recording.hasRecording) {
                                            console.debug('No recording in context for callId, fetching for download: ', c._id);
                                            await callRecordingContext.fetchRecordings({ callId: c._id, limit: 5 });
                                            recStatus = callRecordingContext.getRecordingStatus(c._id);
                                          }
                                          if (!recStatus || !recStatus.recording || !recStatus.recording.hasRecording) {
                                            // Fallback: attempt to download using callId directly
                                            try {
                                              const url = crPlay(c._id).replace('/stream', '/download');
                                              // quick check
                                              try {
                                                const head = await fetch(url, { method: 'HEAD' });
                                                if (!head.ok) {
                                                  showSnackbar('Kayıt dosyası sunucuda bulunamadı', 'warning');
                                                  return;
                                                }
                                              } catch (err) {
                                                console.debug('HEAD for download failed', err);
                                              }
                                              crDownload(c._id);
                                            } catch (e) {
                                              console.error('Download error', e);
                                              showSnackbar('Kayıt indirilirken hata oluştu', 'error');
                                            }
                                            return;
                                          }
                                          try {
                                            crDownload(c._id);
                                          } catch (e) {
                                            console.error('Download error', e);
                                            showSnackbar('Kayıt indirilirken hata oluştu', 'error');
                                          }
                                        }} title="İndir">
                                          <IconDownload size={16} />
                                        </IconButton>
                                      </>
                                    )}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            );
                          })
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Basit Sayfalama */}
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Toplam: {callsTotal} | Sayfa {callsPage}/{callsTotalPages}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Button variant="outlined" size="small" disabled={callsPage <= 1 || callsLoading} onClick={() => setCallsPage((p) => Math.max(1, p - 1))}>Önceki</Button>
                      <Button variant="outlined" size="small" disabled={callsPage >= callsTotalPages || callsLoading} onClick={() => setCallsPage((p) => p + 1)}>Sonraki</Button>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          )}

          {/* Raporlar Sekmesi */}
          {activeSection === 'reports' && (
            <Box>
              {/* Date Range Picker ve Tab Butonları */}
              <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', border: '1px solid rgba(0,0,0,0.05)', mb: 3, bgcolor: '#f8fafc' }}>
                <CardContent sx={{ p: 3 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid size={{ xs: 12, md: 6 }}>
                      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#152b69' }}>
                        📊 Rapor Modülü
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                          <DatePicker
                            label="Başlangıç Tarihi"
                            value={reportDateRange.startDate}
                            onChange={(date) => setReportDateRange({ ...reportDateRange, startDate: date || new Date() })}
                            slotProps={{ textField: { size: 'small', sx: { bgcolor: 'white' } } }}
                          />
                          <DatePicker
                            label="Bitiş Tarihi"
                            value={reportDateRange.endDate}
                            onChange={(date) => setReportDateRange({ ...reportDateRange, endDate: date || new Date() })}
                            slotProps={{ textField: { size: 'small', sx: { bgcolor: 'white' } } }}
                          />
                        </Box>
                      </LocalizationProvider>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <Box sx={{ display: 'flex', gap: 1, justifyContent: { xs: 'flex-start', md: 'flex-end' }, flexWrap: 'wrap' }}>
                        <Button
                          variant={activeReportTab === 'calls' ? 'contained' : 'outlined'}
                          onClick={() => setActiveReportTab('calls')}
                          sx={{ 
                            borderRadius: 2,
                            bgcolor: activeReportTab === 'calls' ? '#4f46e5' : 'white',
                            '&:hover': { bgcolor: activeReportTab === 'calls' ? '#4338ca' : '#f3f4f6' }
                          }}
                        >
                          Çağrı Raporu
                        </Button>
                        <Button
                          variant={activeReportTab === 'agents' ? 'contained' : 'outlined'}
                          onClick={() => setActiveReportTab('agents')}
                          sx={{ 
                            borderRadius: 2,
                            bgcolor: activeReportTab === 'agents' ? '#10b981' : 'white',
                            '&:hover': { bgcolor: activeReportTab === 'agents' ? '#059669' : '#f3f4f6' }
                          }}
                        >
                          Agent Raporu
                        </Button>
                        <Button
                          variant={activeReportTab === 'queues' ? 'contained' : 'outlined'}
                          onClick={() => setActiveReportTab('queues')}
                          sx={{ 
                            borderRadius: 2,
                            bgcolor: activeReportTab === 'queues' ? '#8b5cf6' : 'white',
                            '&:hover': { bgcolor: activeReportTab === 'queues' ? '#7c3aed' : '#f3f4f6' }
                          }}
                        >
                          Kuyruk Raporu
                        </Button>
                        <Button
                          variant={activeReportTab === 'status' ? 'contained' : 'outlined'}
                          onClick={() => setActiveReportTab('status')}
                          sx={{ 
                            borderRadius: 2,
                            bgcolor: activeReportTab === 'status' ? '#ec4899' : 'white',
                            '&:hover': { bgcolor: activeReportTab === 'status' ? '#db2777' : '#f3f4f6' }
                          }}
                        >
                          Statü Raporu
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              {/* Report Content */}
              {activeReportTab === 'calls' && (
                <CallReports 
                  startDate={reportDateRange.startDate.toISOString().split('T')[0]} 
                  endDate={reportDateRange.endDate.toISOString().split('T')[0]} 
                />
              )}
              {activeReportTab === 'agents' && (
                <AgentReports 
                  startDate={reportDateRange.startDate.toISOString().split('T')[0]} 
                  endDate={reportDateRange.endDate.toISOString().split('T')[0]} 
                />
              )}
              {activeReportTab === 'queues' && (
                <QueueReports 
                  startDate={reportDateRange.startDate.toISOString().split('T')[0]} 
                  endDate={reportDateRange.endDate.toISOString().split('T')[0]} 
                />
              )}
              {activeReportTab === 'status' && (
                <StatusReports 
                  startDate={reportDateRange.startDate.toISOString().split('T')[0]} 
                  endDate={reportDateRange.endDate.toISOString().split('T')[0]} 
                />
              )}
            </Box>
          )}

          {/* Destek Talebi Sekmesi */}
          {activeSection === 'support' && (
            <Box sx={{ maxWidth: 800, mx: 'auto' }}>
              <Card sx={{ 
                borderRadius: 3, 
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)', 
                border: '1px solid rgba(0,0,0,0.05)', 
                bgcolor: '#f8fafc' 
              }}>
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <IconHelp size={32} color="#4f46e5" />
                    <Typography variant="h5" sx={{ fontWeight: 'bold', ml: 2, color: '#152b69' }}>
                      Destek Talebi
                    </Typography>
                  </Box>
                  
                  <Typography variant="body2" sx={{ mb: 3, color: '#6b7280' }}>
                    Herhangi bir sorun veya talep için aşağıdaki formu doldurarak bize ulaşabilirsiniz.
                    Talebiniz en kısa sürede değerlendirilecektir.
                  </Typography>

                  {/* Öncelik Seçimi */}
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <InputLabel>Öncelik</InputLabel>
                    <Select
                      value={supportPriority}
                      label="Öncelik"
                      onChange={(e) => setSupportPriority(e.target.value as 'low' | 'medium' | 'high' | 'critical')}
                      sx={{ bgcolor: 'white' }}
                    >
                      <MenuItem value="low">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#22c55e' }} />
                          Düşük
                        </Box>
                      </MenuItem>
                      <MenuItem value="medium">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#f59e0b' }} />
                          Orta
                        </Box>
                      </MenuItem>
                      <MenuItem value="high">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#ef4444' }} />
                          Yüksek
                        </Box>
                      </MenuItem>
                      <MenuItem value="critical">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#dc2626' }} />
                          Kritik
                        </Box>
                      </MenuItem>
                    </Select>
                  </FormControl>

                  {/* Konu */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#374151' }}>
                      Konu
                    </Typography>
                    <input
                      type="text"
                      value={supportSubject}
                      onChange={(e) => setSupportSubject(e.target.value)}
                      placeholder="Destek talebinizin konusu"
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        fontSize: '14px',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        outline: 'none',
                        backgroundColor: 'white',
                        boxSizing: 'border-box'
                      }}
                    />
                  </Box>

                  {/* Mesaj */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#374151' }}>
                      Mesaj
                    </Typography>
                    <textarea
                      value={supportMessage}
                      onChange={(e) => setSupportMessage(e.target.value)}
                      placeholder="Sorununuzu veya talebinizi detaylı olarak açıklayın..."
                      rows={6}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        fontSize: '14px',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        outline: 'none',
                        backgroundColor: 'white',
                        resize: 'vertical',
                        fontFamily: 'inherit',
                        boxSizing: 'border-box'
                      }}
                    />
                  </Box>

                  {/* Gönder Butonu */}
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleSendSupport}
                    disabled={sendingSupport || !supportSubject.trim() || !supportMessage.trim()}
                    startIcon={sendingSupport ? <CircularProgress size={20} color="inherit" /> : <IconSend size={20} />}
                    sx={{
                      bgcolor: '#4f46e5',
                      py: 1.5,
                      fontSize: '16px',
                      fontWeight: 600,
                      borderRadius: 2,
                      '&:hover': { bgcolor: '#4338ca' },
                      '&:disabled': { bgcolor: '#9ca3af' }
                    }}
                  >
                    {sendingSupport ? 'Gönderiliyor...' : 'Destek Talebi Gönder'}
                  </Button>
                </CardContent>
              </Card>
            </Box>
          )}

          {/* ✨ Mesajlar Sekmesi */}
          {activeSection === 'messages' && (
            <Box sx={{ height: 'calc(100vh - 150px)' }}>
              <Box sx={{ height: '100%', display: 'flex', border: '1px solid #e2e8f0', borderRadius: 2, overflow: 'hidden', bgcolor: 'white' }}>
                {/* Conversations List */}
                <Box sx={{ width: '350px', borderRight: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ p: 2.5, borderBottom: '1px solid #e2e8f0', bgcolor: '#f8fafc' }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#1e293b', display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                      <IconSend size={24} />
                      Tüm Mesajlaşmalar
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#64748b', mb: 1.5, display: 'block' }}>
                      Agent'lar arası tüm konuşmaları görüntüleyin
                    </Typography>
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={() => setShowUserSelectDialog(true)}
                      sx={{
                        bgcolor: '#3b82f6',
                        '&:hover': { bgcolor: '#2563eb' },
                        textTransform: 'none'
                      }}
                    >
                      + Yeni Mesaj
                    </Button>
                  </Box>
                  <Box sx={{ flex: 1, overflow: 'auto' }}>
                    {loadingMessages ? (
                      <Box display="flex" justifyContent="center" alignItems="center" py={8}>
                        <CircularProgress />
                      </Box>
                    ) : conversations.length === 0 ? (
                      <Box sx={{ textAlign: 'center', py: 8, px: 3 }}>
                        <IconSend size={48} color="#94a3b8" style={{ marginBottom: 16 }} />
                        <Typography variant="body2" sx={{ color: '#94a3b8', mb: 2 }}>
                          Henüz mesajlaşma bulunmuyor
                        </Typography>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => setShowUserSelectDialog(true)}
                          sx={{ textTransform: 'none' }}
                        >
                          İlk Mesajı Gönder
                        </Button>
                      </Box>
                    ) : (
                      conversations.map((conv: any) => {
                        // Get both users involved in conversation
                        const user1 = conv.lastMessage?.senderId;
                        const user2 = conv.lastMessage?.receiverId;
                        const lastMessagePreview = conv.lastMessage?.content?.substring(0, 60) || '';
                        const timestamp = conv.lastMessage?.createdAt ? new Date(conv.lastMessage.createdAt).toLocaleString('tr-TR', { 
                          day: '2-digit', 
                          month: '2-digit', 
                          hour: '2-digit', 
                          minute: '2-digit' 
                        }) : '';
                        
                        return (
                          <Box
                            key={`${conv._id?.user1}-${conv._id?.user2}`}
                            onClick={() => {
                              setSelectedConversation(conv);
                              loadConversationMessages(user1?._id, user2?._id);
                            }}
                            sx={{
                              p: 2,
                              cursor: 'pointer',
                              borderBottom: '1px solid #f1f5f9',
                              bgcolor: selectedConversation?._id?.user1 === conv._id?.user1 && selectedConversation?._id?.user2 === conv._id?.user2 ? '#f8fafc' : 'white',
                              '&:hover': { bgcolor: '#f8fafc' },
                              transition: 'background-color 0.2s'
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                              <Box sx={{ display: 'flex', position: 'relative' }}>
                                <Avatar sx={{ bgcolor: '#3b82f6', width: 36, height: 36 }}>
                                  {user1?.firstName?.charAt(0).toUpperCase() || 'U'}
                                </Avatar>
                                <Avatar sx={{ bgcolor: '#8b5cf6', width: 36, height: 36, ml: -1.5, border: '2px solid white' }}>
                                  {user2?.firstName?.charAt(0).toUpperCase() || 'U'}
                                </Avatar>
                              </Box>
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#1e293b', mb: 0.5 }}>
                                  {user1?.firstName} {user1?.lastName} ↔ {user2?.firstName} {user2?.lastName}
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#64748b', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                  {lastMessagePreview}
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.7rem', mt: 0.5, display: 'block' }}>
                                  {timestamp}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        );
                      })
                    )}
                  </Box>
                </Box>

                {/* Messages Display */}
                {selectedConversation ? (
                  <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    {/* Header */}
                    <Box sx={{ p: 2.5, borderBottom: '1px solid #e2e8f0', bgcolor: '#f8fafc' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ display: 'flex', position: 'relative' }}>
                          <Avatar sx={{ bgcolor: '#3b82f6', width: 40, height: 40 }}>
                            {selectedConversation.lastMessage?.senderId?.firstName?.charAt(0).toUpperCase() || 'U'}
                          </Avatar>
                          <Avatar sx={{ bgcolor: '#8b5cf6', width: 40, height: 40, ml: -1.5, border: '2px solid white' }}>
                            {selectedConversation.lastMessage?.receiverId?.firstName?.charAt(0).toUpperCase() || 'U'}
                          </Avatar>
                        </Box>
                        <Box>
                          <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                            {selectedConversation.lastMessage?.senderId?.firstName} {selectedConversation.lastMessage?.senderId?.lastName} ↔ {selectedConversation.lastMessage?.receiverId?.firstName} {selectedConversation.lastMessage?.receiverId?.lastName}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#64748b' }}>
                            Mesajlaşma Geçmişi
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Messages */}
                    <Box sx={{ flex: 1, overflow: 'auto', p: 3, bgcolor: '#f8fafc' }}>
                      {messages.length === 0 ? (
                        <Box sx={{ textAlign: 'center', py: 8 }}>
                          <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                            Mesaj bulunamadı
                          </Typography>
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          {messages.map((msg: any) => {
                            const senderName = `${msg.senderId?.firstName || ''} ${msg.senderId?.lastName || ''}`.trim();
                            const receiverName = `${msg.receiverId?.firstName || ''} ${msg.receiverId?.lastName || ''}`.trim();
                            return (
                              <Box
                                key={msg._id}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'flex-start',
                                  gap: 0.5
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Avatar sx={{ bgcolor: '#3b82f6', width: 28, height: 28, fontSize: '0.85rem' }}>
                                    {msg.senderId?.firstName?.charAt(0).toUpperCase() || 'U'}
                                  </Avatar>
                                  <Typography variant="caption" sx={{ fontWeight: 600, color: '#475569' }}>
                                    {senderName} → {receiverName}
                                  </Typography>
                                  <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                                    {new Date(msg.createdAt).toLocaleString('tr-TR', { 
                                      day: '2-digit', 
                                      month: '2-digit',
                                      hour: '2-digit', 
                                      minute: '2-digit' 
                                    })}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    p: 2,
                                    ml: 4.5,
                                    borderRadius: 2,
                                    bgcolor: 'white',
                                    maxWidth: '70%',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                    border: '1px solid #e2e8f0'
                                  }}
                                >
                                  <Typography variant="body2" sx={{ color: '#1e293b', wordBreak: 'break-word' }}>
                                    {msg.content}
                                  </Typography>
                                  {msg.isRead && (
                                    <Typography variant="caption" sx={{ color: '#10b981', display: 'block', mt: 0.5 }}>
                                      ✓✓ Okundu
                                    </Typography>
                                  )}
                                </Box>
                              </Box>
                            );
                          })}
                        </Box>
                      )}
                    </Box>

                    {/* Message Input - Only show for new conversations with selectedUser */}
                    {selectedUser && !selectedConversation && (
                      <Box sx={{ p: 2, borderTop: '1px solid #e2e8f0', bgcolor: 'white' }}>
                        <Box sx={{ mb: 1.5 }}>
                          <Chip 
                            avatar={<Avatar sx={{ bgcolor: '#3b82f6' }}>{(selectedUser.firstName?.[0] || '?').toUpperCase()}</Avatar>}
                            label={`${selectedUser.firstName} ${selectedUser.lastName}`}
                            onDelete={() => setSelectedUser(null)}
                            sx={{ bgcolor: '#f1f5f9' }}
                          />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="Mesajınızı yazın..."
                            value={newMessage}
                            onChange={(e) => setNewMessage(e.target.value)}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter' && !e.shiftKey && newMessage.trim()) {
                                e.preventDefault();
                                handleSendMessage();
                              }
                            }}
                            multiline
                            maxRows={3}
                          />
                          <Button
                            variant="contained"
                            onClick={handleSendMessage}
                            disabled={!newMessage.trim()}
                            sx={{
                              bgcolor: '#3b82f6',
                              '&:hover': { bgcolor: '#2563eb' },
                              minWidth: '100px'
                            }}
                          >
                            Gönder
                          </Button>
                        </Box>
                      </Box>
                    )}
                  </Box>
                ) : selectedUser ? (
                  <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    {/* Header for new conversation */}
                    <Box sx={{ p: 2.5, borderBottom: '1px solid #e2e8f0', bgcolor: '#f8fafc' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar sx={{ bgcolor: '#3b82f6', width: 40, height: 40 }}>
                          {(selectedUser.firstName?.[0] || '?').toUpperCase()}
                        </Avatar>
                        <Box>
                          <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                            {selectedUser.firstName} {selectedUser.lastName}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#64748b' }}>
                            Yeni Mesajlaşma
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Empty state for new conversation */}
                    <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f8fafc' }}>
                      <Box sx={{ textAlign: 'center' }}>
                        <IconSend size={64} color="#94a3b8" style={{ marginBottom: 16 }} />
                        <Typography variant="h6" sx={{ color: '#64748b', mb: 1 }}>
                          İlk Mesajı Gönderin
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                          {selectedUser.firstName} ile mesajlaşmaya başlayın
                        </Typography>
                      </Box>
                    </Box>

                    {/* Message Input */}
                    <Box sx={{ p: 2, borderTop: '1px solid #e2e8f0', bgcolor: 'white' }}>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <TextField
                          fullWidth
                          size="small"
                          placeholder="Mesajınızı yazın..."
                          value={newMessage}
                          onChange={(e) => setNewMessage(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey && newMessage.trim()) {
                              e.preventDefault();
                              handleSendMessage();
                            }
                          }}
                          multiline
                          maxRows={3}
                        />
                        <Button
                          variant="contained"
                          onClick={handleSendMessage}
                          disabled={!newMessage.trim()}
                          sx={{
                            bgcolor: '#3b82f6',
                            '&:hover': { bgcolor: '#2563eb' },
                            minWidth: '100px'
                          }}
                        >
                          Gönder
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f8fafc' }}>
                    <Box sx={{ textAlign: 'center' }}>
                      <IconSend size={64} color="#94a3b8" style={{ marginBottom: 16 }} />
                      <Typography variant="h6" sx={{ color: '#64748b', mb: 1 }}>
                        Mesajlaşmayı Görüntüle
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                        Soldaki listeden bir konuşma seçin
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>

              {/* User Selection Dialog */}
              <Dialog 
                open={showUserSelectDialog} 
                onClose={() => setShowUserSelectDialog(false)}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6">Kullanıcı Seç</Typography>
                    <IconButton size="small" onClick={() => setShowUserSelectDialog(false)}>
                      ✕
                    </IconButton>
                  </Box>
                </DialogTitle>
                <DialogContent dividers>
                  <List>
                    {allUsers.map((user) => (
                      <ListItem
                        key={user._id}
                        onClick={() => {
                          setSelectedUser(user);
                          setSelectedConversation(null);
                          setMessages([]);
                          setShowUserSelectDialog(false);
                        }}
                        sx={{
                          borderRadius: 1,
                          mb: 0.5,
                          cursor: 'pointer',
                          '&:hover': { bgcolor: '#f8fafc' }
                        }}
                      >
                        <Avatar sx={{ bgcolor: '#3b82f6', mr: 2 }}>
                          {(user.firstName?.[0] || user.email?.[0] || '?').toUpperCase()}
                        </Avatar>
                        <ListItemText
                          primary={user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.email}
                          secondary={user.role}
                        />
                      </ListItem>
                    ))}
                  </List>
                </DialogContent>
              </Dialog>
            </Box>
          )}

          {/* Dialer Yönetimi Sekmesi */}
          {activeSection === 'campaigns' && (
            <Box sx={{ height: 'calc(100vh - 150px)', overflow: 'auto' }}>
              <CampaignDashboard />
            </Box>
          )}
        </Box>
      </Box>

        {/* Inline audio player dialog for supervisor calls */}
        <Dialog open={playerDialog.open} onClose={() => setPlayerDialog({ ...playerDialog, open: false })} maxWidth="sm" fullWidth>
          <DialogTitle>Çağrı Kaydı - {playerDialog.title}</DialogTitle>
          <DialogContent>
            <Box sx={{ mb: 2 }}>
              <div ref={waveformRef} style={{ width: '100%' }} />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
              <Box>
                <IconButton onClick={togglePlayPause} size="small" sx={{ mr: 1, bgcolor: '#2563eb', color: 'white' }}>
                  {isPlaying ? <IconPlayerPause size={18} /> : <IconPlayerPlay size={18} />}
                </IconButton>
                <IconButton onClick={stopPlayback} size="small" sx={{ mr: 1 }}>
                  <IconPlayerStop size={18} />
                </IconButton>
                <Typography variant="caption">{new Date(currentTime * 1000).toISOString().substr(11, 8)} / {new Date(duration * 1000).toISOString().substr(11, 8)}</Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '35%' }}>
                <IconVolume size={16} />
                <Slider
                  value={volume}
                  min={0}
                  max={1}
                  step={0.01}
                  onChange={(_e, v) => changeVolume(v as number)}
                />
              </Box>
            </Box>
          </DialogContent>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
            <Button variant="contained" onClick={() => setPlayerDialog({ ...playerDialog, open: false })}>Kapat</Button>
          </Box>
        </Dialog>

      {/* MT Performansı Modal */}
      {isPerformanceModalOpen && selectedAgent && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            animation: 'fadeIn 0.3s ease-in-out',
          }}
        >
          <Fade in={isPerformanceModalOpen} timeout={300}>
            <Box
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(20px)",
                borderRadius: 4,
                width: "95%",
                maxWidth: "1400px",
                maxHeight: "95vh",
                overflow: "auto",
                boxShadow: "0 50px 100px -20px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                animation: `${float} 6s ease-in-out infinite`,
              }}
            >
              {/* Modal Header */}
              <Box sx={{ p: 4, borderBottom: "1px solid #e5e7eb", background: "linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)", backdropFilter: "blur(10px)" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography variant="h4" sx={{ fontWeight: "bold", color: "white", textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)", letterSpacing: "0.5px" }}>
                    MT Performansı
                  </Typography>
                  <IconButton
                    onClick={handleCloseModal}
                    sx={{
                      bgcolor: "rgba(255, 255, 255, 0.1)",
                      color: "white",
                      transition: "all 0.3s ease",
                      borderRadius: 2,
                      p: 1,
                      "&:hover": {
                        bgcolor: "rgba(255, 255, 255, 0.2)",
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <IconX size={20} />
                  </IconButton>
                </Box>


              </Box>

              {/* Modal Content */}
              <Box sx={{ p: 4 }}>
                {/* Agent Info */}
                <Box sx={{ 
                  mb: 4, 
                  p: 3, 
                  borderRadius: 3, 
                  bgcolor: "#f8fafc", 
                  border: "1px solid #e5e7eb",
                  backdropFilter: "blur(10px)"
                }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 3, mb: 3 }}>
                    <Avatar sx={{ 
                      width: 80, 
                      height: 80, 
                      background: `linear-gradient(135deg, ${getStatusColor(selectedAgent?.status || 'Not Answering')} 0%, ${getStatusColor(selectedAgent?.status || 'Not Answering')}dd 100%)`,
                      boxShadow: `0 8px 25px ${getStatusColor(selectedAgent?.status || 'Not Answering')}50`,
                      border: "3px solid white",
                      position: "relative",
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        inset: "-3px",
                        borderRadius: "50%",
                        background: `radial-gradient(circle at 30% 30%, rgba(255,255,255,0.8), ${getStatusColor(selectedAgent?.status || 'Not Answering')}80)`,
                        zIndex: -1,
                      }
                    }}>
                      <Typography variant="h3" sx={{ fontWeight: "bold", color: "white" }}>
                        {selectedAgent?.avatar || "AG"}
                      </Typography>
                    </Avatar>
                    <Box>
                      <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1, textShadow: "0 1px 2px rgba(0, 0, 0, 0.1)", letterSpacing: "0.3px" }}>
                        {selectedAgent?.name}
                      </Typography>
                      <Typography variant="body1" sx={{ color: "#6b7280", fontWeight: 500 }}>
                        {selectedAgent?.email || selectedAgent?.agent?.email}
                      </Typography>
                      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 2, alignItems: "center" }}>
                        <Chip 
                          label={selectedAgent?.status || 'Not Answering'} 
                          sx={{ 
                            bgcolor: getStatusColor(selectedAgent?.status || 'Not Answering'),
                            color: "white",
                            fontWeight: 600,
                            fontSize: "0.875rem",
                            height: 28,
                            boxShadow: `0 2px 8px ${getStatusColor(selectedAgent?.status || 'Not Answering')}50`,
                            "& .MuiChip-label": {
                              px: 1.5
                            }
                          }} 
                        />
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Box sx={{ 
                            width: 8, 
                            height: 8, 
                            bgcolor: getStatusColor(selectedAgent?.status || 'Not Answering'), 
                            borderRadius: "50%",
                            boxShadow: `0 0 10px ${getStatusColor(selectedAgent?.status || 'Not Answering')}50`
                          }} />
                          <Typography variant="body2" sx={{ color: "#6b7280", fontWeight: 500 }}>
                            Statü Süresi: <CallDurationTimer startTime={selectedAgent?.statusStartTime} />
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Box sx={{ 
                            width: 8, 
                            height: 8, 
                            bgcolor: "#3b82f6", 
                            borderRadius: "50%",
                            boxShadow: "0 0 10px rgba(59, 130, 246, 0.5)"
                          }} />
                          <Typography variant="body2" sx={{ color: "#6b7280", fontWeight: 500 }}>
                            Statü Değişikliği: {selectedAgent?.statusChangeTime || "-"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {loadingAgentData ? (
                  <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                  </Box>
                ) : agentPerformanceData ? (
                  <>
                    {/* Performance Stats Grid */}
                    <Grid container spacing={3} sx={{ mb: 4 }}>
                      {/* Toplam Çağrı */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{
                          height: '100%',
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          color: 'text.primary',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(0,0,0,0.08)' }
                        }}>
                          <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <IconPhone size={32} style={{ marginBottom: 12, color: '#64748b' }} />
                            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                              {agentPerformanceData.totalCalls}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                              Toplam Çağrı Adedi
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Gelen Çağrı */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{
                          height: '100%',
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          color: 'text.primary',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(0,0,0,0.08)' }
                        }}>
                          <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <IconPhone size={32} style={{ marginBottom: 12, color: '#64748b' }} />
                            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                              {agentPerformanceData.incomingCalls}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                              Gelen Çağrı Adedi
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Giden Çağrı */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{
                          height: '100%',
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          color: 'text.primary',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(0,0,0,0.08)' }
                        }}>
                          <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <IconPhone size={32} style={{ marginBottom: 12, color: '#64748b' }} />
                            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                              {agentPerformanceData.outgoingCalls}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                              Giden Çağrı Adedi
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Toplam Konuşma Süresi */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{
                          height: '100%',
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          color: 'text.primary',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(0,0,0,0.08)' }
                        }}>
                          <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <IconClock size={32} style={{ marginBottom: 12, color: '#64748b' }} />
                            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                              {agentPerformanceData.totalCallDuration}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                              Toplam Konuşma Süresi
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Gelen Çağrı Süresi */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{
                          height: '100%',
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          color: 'text.primary',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(0,0,0,0.08)' }
                        }}>
                          <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <IconClock size={32} style={{ marginBottom: 12, color: '#64748b' }} />
                            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                              {agentPerformanceData.incomingCallDuration}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                              Gelen Çağrı Süresi
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Giden Çağrı Süresi */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{
                          height: '100%',
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          color: 'text.primary',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(0,0,0,0.08)' }
                        }}>
                          <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <IconClock size={32} style={{ marginBottom: 12, color: '#64748b' }} />
                            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                              {agentPerformanceData.outgoingCallDuration}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                              Giden Çağrı Süresi
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Ortalama Toplam Çağrı */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{
                          height: '100%',
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          color: 'text.primary',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(0,0,0,0.08)' }
                        }}>
                          <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <IconTarget size={32} style={{ marginBottom: 12, color: '#64748b' }} />
                            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                              {agentPerformanceData.avgTotalCallDuration}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                              Toplam Çağrı Ortalaması
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Ortalama Gelen Çağrı */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{
                          height: '100%',
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          color: 'text.primary',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(0,0,0,0.08)' }
                        }}>
                          <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <IconTarget size={32} style={{ marginBottom: 12, color: '#64748b' }} />
                            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                              {agentPerformanceData.avgIncomingCallDuration}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                              Gelen Çağrı Ortalaması
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Ortalama Giden Çağrı */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={{
                          height: '100%',
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          color: 'text.primary',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(0,0,0,0.08)' }
                        }}>
                          <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <IconTarget size={32} style={{ marginBottom: 12, color: '#64748b' }} />
                            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                              {agentPerformanceData.avgOutgoingCallDuration}
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                              Giden Çağrı Ortalaması
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>

                    {/* Statü Süreleri (Bugün) — AgentPanel ile aynı mantık, tablo olarak */}
                    <Card sx={{ borderRadius: 3, mt: 3 }}>
                      <CardContent>
                        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 3 }}>
                          Statü Süreleri (Bugün)
                        </Typography>
                        <TableContainer sx={{ maxHeight: 340 }}>
                          <Table stickyHeader size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Statü</TableCell>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Toplam Süre</TableCell>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Değişiklik</TableCell>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Oran</TableCell>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Aktif mi</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(!agentStatusDurations || agentStatusDurations.length === 0) ? (
                                <TableRow>
                                  <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                                    <Typography variant="body2" color="text.secondary">
                                      Bugün için statü süresi verisi bulunamadı
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                agentStatusDurations.map((s: any, idx: number) => {
                                  const name = s.statusName || s.name || '-';
                                  const durationSec = typeof s.durationSeconds === 'number' ? s.durationSeconds : (typeof s.totalDuration === 'number' ? s.totalDuration : 0);
                                  const formatted = s.formattedDuration || (() => {
                                    const hours = Math.floor(durationSec / 3600);
                                    const minutes = Math.floor((durationSec % 3600) / 60);
                                    const secs = durationSec % 60;
                                    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
                                  })();
                                  const count = typeof s.count === 'number' ? s.count : (typeof s.changeCount === 'number' ? s.changeCount : 0);
                                  const ratio = typeof s.ratio === 'number' ? s.ratio : (typeof s.percentage === 'number' ? s.percentage : null);
                                  const active = !!s.isCurrent;
                                  return (
                                    <TableRow key={idx}>
                                      <TableCell sx={{ fontWeight: 500 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: getStatusColor(name) }} />
                                          {name}
                                        </Box>
                                      </TableCell>
                                      <TableCell>{formatted}</TableCell>
                                      <TableCell>{count}</TableCell>
                                      <TableCell>{ratio !== null ? `${Math.round(ratio)}%` : '-'}</TableCell>
                                      <TableCell>
                                        {active ? (
                                          <Chip label="Aktif" size="small" sx={{ bgcolor: '#10b981', color: 'white', fontWeight: 600 }} />
                                        ) : (
                                          <Chip label="Pasif" size="small" sx={{ bgcolor: '#6b7280', color: 'white' }} />
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </CardContent>
                    </Card>

                    {/* Call History */}
                    <Card sx={{ borderRadius: 3, mt: 3 }}>
                      <CardContent>
                        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 3 }}>
                          Arama Geçmişi
                        </Typography>
                        <TableContainer sx={{ maxHeight: 400 }}>
                          <Table stickyHeader>
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Tarih</TableCell>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Müşteri</TableCell>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Telefon</TableCell>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Yön</TableCell>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Süre</TableCell>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Durum</TableCell>
                                <TableCell sx={{ fontWeight: 600, bgcolor: '#f8fafc' }}>Sonuç Kodu</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {agentCallHistory.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                                    <Typography variant="body2" color="text.secondary">
                                      Henüz arama geçmişi bulunmuyor
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                agentCallHistory.map((call: any, index: number) => {
                                  // Telefon ve müşteri adı alanlarını çağrı yönüne göre doğru eşle
                                  const phone = call.direction === 'incoming'
                                    ? (call.callerNumber || call.calledNumber)
                                    : (call.calledNumber || call.callerNumber);

                                  const customerName = call.callerName
                                    || (call.direction === 'incoming' ? call.callerNumber : call.calledNumber)
                                    || '-';

                                  // Süre formatlama (ss → HH:MM:SS)
                                  const formatSeconds = (seconds: any) => {
                                    const s = Number(seconds);
                                    if (!isFinite(s) || isNaN(s)) return '00:00:00';
                                    const hours = Math.floor(s / 3600);
                                    const minutes = Math.floor((s % 3600) / 60);
                                    const secs = Math.floor(s % 60);
                                    return `${hours.toString().padStart(2, '0')}:${minutes
                                      .toString()
                                      .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
                                  };

                                  const statusLabel = (() => {
                                    switch (call.status) {
                                      case 'ended':
                                      case 'completed':
                                        return 'Tamamlandı';
                                      case 'failed':
                                        return 'Başarısız';
                                      case 'ringing':
                                        return 'Çalıyor';
                                      case 'answered':
                                        return 'Yanıtlandı';
                                      case 'waiting':
                                        return 'Bekliyor';
                                      default:
                                        return call.status || '-';
                                    }
                                  })();

                                  const statusColor: any = (call.status === 'ended' || call.status === 'completed')
                                    ? 'success'
                                    : (call.status === 'failed' ? 'error' : 'default');

                                  return (
                                    <TableRow key={index} hover>
                                      <TableCell>
                                        {new Date(call.startTime || call.createdAt).toLocaleString('tr-TR')}
                                      </TableCell>
                                      <TableCell>{customerName}</TableCell>
                                      <TableCell>{phone || '-'}</TableCell>
                                      <TableCell>
                                        <Chip
                                          label={call.direction === 'incoming' ? 'Gelen' : 'Giden'}
                                          size="small"
                                          color={call.direction === 'incoming' ? 'primary' : 'secondary'}
                                        />
                                      </TableCell>
                                      <TableCell>{formatSeconds(call.duration)}</TableCell>
                                      <TableCell>
                                        <Chip
                                          label={statusLabel}
                                          size="small"
                                          color={statusColor}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        {call.finishCode ? (
                                          <Chip
                                            label={typeof call.finishCode === 'object' ? call.finishCode.name : call.finishCode}
                                            size="small"
                                            sx={{ 
                                              bgcolor: typeof call.finishCode === 'object' && call.finishCode.color ? call.finishCode.color : '#6b7280',
                                              color: 'white',
                                              fontSize: '0.7rem'
                                            }}
                                          />
                                        ) : (
                                          <Typography variant="body2" color="text.secondary">-</Typography>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </CardContent>
                    </Card>
                  </>
                ) : (
                  <Box textAlign="center" py={4}>
                    <Typography variant="body1" color="text.secondary">
                      Performans verileri yüklenemedi
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Fade>
        </Box>
      )}
    </Box>
  );
};

// Navigation Item Component
const NavItem: React.FC<{ icon: React.ReactNode; label: string }> = ({ icon, label }) => (
  <Box sx={{ 
    display: "flex", 
    flexDirection: "column", 
    alignItems: "center", 
    gap: 0.5,
    p: 1,
    borderRadius: 2,
    transition: "all 0.3s ease",
    cursor: "pointer",
    bgcolor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    "&:hover": {
      bgcolor: "rgba(255, 255, 255, 0.2)",
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    }
  }}>
    <Box sx={{ color: "white" }}>{icon}</Box>
    <Typography variant="caption" sx={{ color: "white", fontSize: "0.6rem", fontWeight: 500 }}>
      {label}
    </Typography>
  </Box>
);

export default SupervisorDashboard;